import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  List,
  Modal,
  ListItem,
  ListItemText,
  Link,
  CircularProgress,
  TextField,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  MenuItem,
  Card,
  CardContent,
  Snackbar,
  Tab,
  Tabs,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ReactComponent as ImgIcon } from "./src/ic-img.svg"; // Import the SVG icon
import { ReactComponent as DocIcon } from "./src/ic-document.svg"; // Import the SVG icon
import PdfIcon from "./src/ic-pdf.svg"; // actualizează calea la iconul PDF
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AwbAccordion from "./CreareAWB"; // Importăm noul component
import Alert from "@mui/material/Alert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // Import the check icon
import ActiveRequests from "./ActiveRequests"; // importă componenta
import RestituitCerereTab from "./tabs/RestituitCerereTab";
import AnalysisIcon from "@mui/icons-material/Analytics"; // Importați icon-ul pentru analiză
import Page18 from "./Page18"; // Importă noua componentă
import AutentificareStep from "./autentificare_step"; // Importăm noua componentă
import CreareContractForm from "./CreareContractForm"; // Import contract form
import ActeConfidentiale from "./ActeConfidentiale";
import VendorInfo from "./VendorInfo";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CreareaCerereRetur from "./CreareaCerereRetur";
import { ReturContext } from "./ReturContext";
import { useContext } from "react";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import StorefrontIcon from "@mui/icons-material/Storefront";
import API_BASE_URL, { buildApiUrl } from "./apiConfig";
import STATUS_API_BASE, { buildStatusApiUrl } from "./statusApiConfig";

const API_BASE = API_BASE_URL;

const STATUS_SUCCESS_MESSAGE = "Status actualizat";
const STATUS_ERROR_MESSAGE = "Nu am putut actualiza statusul.";

const SELL_NOW_ACCEPT_NOTE = "Acceptat din BOBO";
const SELL_NOW_ACQUISITION_TYPES = [
  "LP001 – Contract de consignatie data variabila",
  "LP002 – Contract de CN data variabila cu promisiune de vanzare la final",
  "LP003 – Contract de VD cu Voucher",
  "LP004 – Contract de VD Standard 5 zile",
  "LP005 – Contract de VD cu data variabila",
  "LP006 Contract FAST Sale 24h",
  "LP013 – Act aditional CN",
  "LP014 – Act aditional VD",
];

const normalizeSellNowAcquisitionType = (value) => {
  const normalized = String(value || "").trim().replace(/\s+/g, " ");
  if (!normalized) return "";
  if (SELL_NOW_ACQUISITION_TYPES.includes(normalized)) return normalized;

  const dashNormalized = normalized.replace(/\s+-\s+/g, " – ");
  if (SELL_NOW_ACQUISITION_TYPES.includes(dashNormalized)) {
    return dashNormalized;
  }

  return "";
};

const parsePositiveAdminAmount = (value) => {
  const normalized =
    typeof value === "number"
      ? value
      : Number(String(value || "").trim().replace(",", "."));

  return Number.isFinite(normalized) && normalized > 0 ? normalized : null;
};

const richTextFieldToPlainText = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;

  const traverse = (node) => {
    if (!node) return "";
    if (Array.isArray(node)) {
      return node.map(traverse).join("");
    }
    const { type, text, content } = node;
    switch (type) {
      case "doc":
        return traverse(content);
      case "paragraph":
        return `${traverse(content)}\n`;
      case "text":
        return text || "";
      case "hardBreak":
        return "\n";
      default:
        return traverse(content);
    }
  };

  return traverse(value).replace(/\n+$/, "");
};

const plainTextToRichTextField = (text) => {
  const normalized = (text || "").replace(/\r\n/g, "\n");
  const lines = normalized.length > 0 ? normalized.split("\n") : [""];

  return {
    type: "doc",
    version: 1,
    content: lines.map((line) => ({
      type: "paragraph",
      content: line
        ? [
            {
              type: "text",
              text: line,
            },
          ]
        : [],
    })),
  };
};

const TaskEdit = ({
  issueId,
  style,
  tab,
  setTab,
  onClose,
  onPanelClose,
  reloadTasks,
  onTaskTransition,
  cerereId,
  emailFromRestituit,
}) => {
  const { returEmail, returNume, returTelefon } = useContext(ReturContext);
  console.log(
    "[✅ TASKEDIT] ID cerere primit din RestituitCerereTab:",
    cerereId
  );
  // Local tab state and setter fallback if not provided by parent
  const [internalTab, setInternalTab] = useState("created");
  const currentTab = typeof tab !== "undefined" ? tab : internalTab;
  const updateTab = typeof setTab === "function" ? setTab : setInternalTab;
  // --- File Input Ref and Main Image Upload Handler ---
  const fileInputRef = useRef(null);
  const mainImageDropRef = useRef(null);
  const pointerImageDragRef = useRef(null);
  const pointerDragClickGuardRef = useRef(false);
  const statusMessageTimeoutRef = useRef(null);
  const lastSavedBankRef = useRef("");
  const lastSavedIbanRef = useRef("");
  const lastSavedConfidentialRef = useRef({
    cnp: "",
    serieCI: "",
    nrCI: "",
  });

  const handlePanelClose = () => {
    if (typeof onPanelClose === "function") {
      onPanelClose();
      return;
    }
    if (typeof onClose === "function") {
      onClose();
    }
  };

  const getWooPostIdFromSku = (skuValue) => {
    if (!skuValue || typeof skuValue !== "string") return "";
    const match = skuValue.trim().match(/[A-Za-z]+(\d+)/);
    if (!match || !match[1]) return "";
    return match[1].replace(/^0+/, "");
  };

  const extractEntryIdFromSummary = (summaryValue = "") => {
    const normalized = String(summaryValue || "").trim();
    if (!normalized) return "";

    const firstNumericGroup = normalized.match(/\b(\d+)\b/);
    return firstNumericGroup?.[1] || "";
  };

  const resolveCustomFieldOptionLabel = (fieldId, selectedValue) => {
    const options = Array.isArray(customFieldOptions[fieldId])
      ? customFieldOptions[fieldId]
      : [];
    const normalizedSelectedValue = String(selectedValue || "").trim();
    if (!normalizedSelectedValue) return "";

    const matchedOption = options.find(
      (option) =>
        String(option.value) === normalizedSelectedValue ||
        String(option.label) === normalizedSelectedValue
    );

    if (matchedOption?.label) return matchedOption.label;

    const taskFieldValue = task?.[fieldId];
    if (
      taskFieldValue &&
      typeof taskFieldValue === "object" &&
      (String(taskFieldValue.id || "") === normalizedSelectedValue ||
        String(taskFieldValue.value || "") === normalizedSelectedValue)
    ) {
      return (
        taskFieldValue.value || taskFieldValue.label || normalizedSelectedValue
      );
    }

    return normalizedSelectedValue;
  };

  const buildAcceptSyncPayload = () => {
    const effectiveSummary = (newSummary || summary || "").trim();
    const productId = extractEntryIdFromSummary(effectiveSummary);
    const adminAmount = parsePositiveAdminAmount(
      customFieldValues.customfield_10072
    );
    const acquisitionType = normalizeSellNowAcquisitionType(
      resolveCustomFieldOptionLabel(
        "customfield_10183",
        customFieldValues.customfield_10183
      )
    );

    if (!productId) {
      throw new Error("Nu am găsit ID-ul numeric Sell Now în sumarul cererii.");
    }

    if (adminAmount === null) {
      throw new Error("Amount (RON) trebuie completat cu o valoare pozitivă.");
    }

    if (!acquisitionType) {
      throw new Error(
        "Acquisition type trebuie să fie una dintre politicile LP valide."
      );
    }

    return {
      issueId,
      summary: effectiveSummary,
      productId,
      adminAmount,
      acquisitionType,
      note: SELL_NOW_ACCEPT_NOTE,
    };
  };

  const handleOpenJira = () => {
    if (!issueId) return;
    const url = `https://luxura.atlassian.net/browse/${issueId}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleOpenWooAdmin = () => {
    const postId = getWooPostIdFromSku(customFieldValues.customfield_10083);
    if (!postId) return;
    const url = `https://luxuraelite.ro/wp-admin/post.php?post=${postId}&action=edit&lang=ro`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleMainImageIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleMainImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    formData.append("issueKey", issueId);

    try {
      const response = await axios.post(
        buildApiUrl("/api/tasks/jira/upload-attachment"),
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      const uploaded = response.data.attachments?.[0];
      if (uploaded) {
        const uploadedAttachment = {
          id: uploaded.id,
          filename: uploaded.filename,
          mimeType: uploaded.mimeType,
          size: uploaded.size,
          url: uploaded.content,
          created: uploaded.created,
          author: uploaded.author?.displayName || "",
        };
        setFirstImageAttachment(uploadedAttachment);
        setAttachments((prev) => [
          uploadedAttachment,
          ...prev.filter(
            (att) => String(att?.id || "") !== String(uploadedAttachment.id)
          ),
        ]);
        await axios.put(buildApiUrl(`/api/tasks/jira-task/${issueId}/main-image`), {
          attachmentId: uploadedAttachment.id,
          attachment: uploadedAttachment,
        });
      }
    } catch (error) {
      console.error("Eroare la încărcarea imaginii în JIRA:", error);
      alert("A apărut o eroare la încărcarea imaginii.");
    }
  };
  const [task, setTask] = useState({});
  const [status, setStatus] = useState("");
  const [summary, setSummary] = useState("");
  const [description, setDescription] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [uniqueId, setUniqueId] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [error, setError] = useState("");
  const [isEditingSummary, setIsEditingSummary] = useState(false);
  const [newSummary, setNewSummary] = useState("");
  const [imageSearchResults, setImageSearchResults] = useState([]);
  const [firstImageAttachment, setFirstImageAttachment] = useState(null);
  const [isMainImageDragOver, setIsMainImageDragOver] = useState(false);
  const [draggedImageAttachment, setDraggedImageAttachment] = useState(null);
  const [pointerDragPreview, setPointerDragPreview] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [tags, setTags] = useState([]);
  const [price, setPrice] = useState("");
  const [expandedHistory, setExpandedHistory] = useState(false);
  const [expandedSearch, setExpandedSearch] = useState(false);
  const [transitions, setTransitions] = useState([]);
  const [selectedTransition, setSelectedTransition] = useState("");
  const [customFieldOptions, setCustomFieldOptions] = useState({});
  const [iban, setIban] = useState(""); // Starea pentru IBAN
  const [bankName, setBankName] = useState(""); // Starea pentru numele băncii
  const [vendorData, setVendorData] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null); // Declara stare pentru selectedAddress
  const [alertMessage, setAlertMessage] = useState(""); // Mesajul alertei
  const [alertType, setAlertType] = useState(""); // Tipul alertei ('success' sau 'error')
  const [showAlert, setShowAlert] = useState(false); // Controlează afișarea alertei
  const [ocrSaveMessage, setOcrSaveMessage] = useState("");
  const [ocrSaveType, setOcrSaveType] = useState("");
  const [showOcrSaveAlert, setShowOcrSaveAlert] = useState(false);

  const [customFieldValues, setCustomFieldValues] = useState({
    customfield_10066: "",
    customfield_10083: "",
    customfield_10077: "",
    customfield_10072: "",
    customfield_10073: "",
    customfield_10080: "",
    customfield_10183: "",
    customfield_10173: "", // New field for Categorie
    customfield_10078: "", // New field for Expira Contract
    customfield_10165: "", // New field for Achizitor
    customfield_10185: "", // New field for Contactat
    customfield_10067: "", // New field for PersonIcon
    customfield_10069: "", // New field for EmailIcon
    customfield_10068: "", // New field for PhoneIcon
    customfield_10186: "", // New field for Nota interna
    customfield_10188: "", // New field for QCRespins
    customfield_10107: "",
    customfield_10170: "",
    customfield_10181: "",
    customfield_10070: "",
    customfield_10175: "", // Banca
    customfield_10176: "", // IBAN
    customfield_10166: "", // Adresă
    customfield_10337: "", // Stoc Extern
  });
  const [history, setHistory] = useState([]);
  const [tipContract, setTipContract] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [details, setDetails] = useState("");
  const [pendingRefuseAction, setPendingRefuseAction] =
    useState("totalRefuse");
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [statusFeedback, setStatusFeedback] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const [warnings, setWarnings] = useState({});
  const [scheduledAwb, setScheduledAwb] = useState(null);
  const [showAnalysis, setShowAnalysis] = useState(false); // Stare pentru a controla vizibilitatea analizei
  const [manualAvgPrice, setManualAvgPrice] = useState(""); // Stare pentru Prețul de Vânzare
  const [contractData, setContractData] = useState({
    nume: "",
    prenume: "",
    telefon: "",
    email: "",
    adresa: "",
    serieCI: "",
    nrCI: "",
    numarContract: "",
    tipContract: "",
    um: "1 BUC", // Set default value here
    dataContract: "",
    panaCand: "",
    pretCuvenit: "",
    model: "",
    categoria: "",
    checkboxOptions: "",
  });
  const sectionRowSx = {
    display: "flex",
    justifyContent: "space-around",
    marginBottom: "0px",
    gap: "0px",
    padding: "0px",
    borderRadius: "0px",
    background: "rgba(248, 250, 252, 0.9)",
    border: "1px solid rgba(148, 163, 184, 0.18)",
  };
  const fieldCardSx = {
    flex: 1,
    padding: "8px 10px",
    borderRadius: "0px",
    background: "#FFFFFF",
    color: "#0F172A",
    border: "1px solid rgba(148, 163, 184, 0.22)",
  };
  const fieldLabelSx = {
    marginLeft: "2px",
    marginBottom: "6px",
    fontWeight: 600,
    letterSpacing: "0.015em",
    color: "#1E293B",
  };
  const controlSx = {
    backgroundColor: "#F8FAFC",
    borderRadius: "10px",
    fontSize: "16px",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(148, 163, 184, 0.4)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#94A3B8",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2563EB",
    },
  };

  const stocExternOption = customFieldOptions.customfield_10337?.find(
    (option) => option.value === customFieldValues.customfield_10337
  );
  const stocExternLabel = (
    stocExternOption?.label ||
    customFieldValues.customfield_10337 ||
    ""
  )
    .toString()
    .trim()
    .toLowerCase();
  const stocExternBg =
    stocExternLabel === "da"
      ? "#FCE7F3"
      : stocExternLabel === "nu"
        ? "#ECFDF3"
        : "#F1F5F9";

  const salReasons = [
    "1. Stare generala uzata: Produsul prezinta semne evidente de uzura, cum ar fi zgarieturi, pete sau decolorari, care nu respecta standardele noastre de calitate.",
    "2. Defecte structurale: Produsul are defecte structurale, cum ar fi cusaturi desfacute, fermoare defecte sau parti lipsa, care afecteaza functionalitatea si estetica.",
    "3. Piese neoriginale sau inlocuite: Am constatat ca anumite componente ale produsului nu sunt originale sau au fost inlocuite, ceea ce afecteaza autenticitatea si valoarea acestuia.",
    "4. Semne de reparatii neautorizate: Produsul prezinta semne de reparatii sau modificari care nu au fost realizate de un specialist autorizat, ceea ce reduce valoarea si integritatea sa.",
    "5. Lipsa documentatiei necesare: Produsul nu este insotit de documentatia necesara, cum ar fi certificate de autenticitate, facturi sau alte acte, ceea ce ne impiedica sa confirmam provenienta si autenticitatea.",
    "6. Miros persistent: Produsul emana un miros persistent care nu poate fi eliminat si care nu este compatibil cu standardele noastre de calitate.",
    "7. Culoare modificata: Culoarea produsului a suferit modificari semnificative, fie din cauza expunerii la soare, fie din alte cauze, ceea ce il face nepotrivit pentru vanzare.",
    "8. Uzura interioara excesiva: Interiorul produsului prezinta semne de uzura excesiva, cum ar fi captuseala deteriorata, pete sau alte defecte, care afecteaza atractivitatea acestuia.",
    "9. Materiale deteriorate: Materialele din care este confectionat produsul, cum ar fi pielea sau metalul, prezinta semne de deteriorare, cum ar fi crapaturi, rugina sau decolorarea.",
    "10. Nerespectarea cerintelor de brand: Produsul nu respecta standardele de calitate si design specifice brandului, ceea ce ne impiedica sa il acceptam pentru vanzare in consignatia noastra.",
    "11. Pretul propus nu a fost acceptat: Dupa evaluarea produsului, pretul nou propus nu a fost acceptat de catre dumneavoastra, ceea ce ne impiedica sa continuam procesul de consignatie.",
    "12. Lipsa accesoriilor sau a componentelor mentionate: Produsul nu a fost insotit de toate accesoriile sau componentele mentionate in cererea initiala, ceea ce ne impiedica sa il acceptam pentru consignatie.",
    "13. Produsul nu poate fi acceptat, deoarece ați refuzat opțiunea de consignare, iar achiziția directă nu se încadrează în politica noastră actuală.",
    "14. Brand: Articolul nu este eligibil deoarece brandul nu se încadrează în portofoliul nostru de produse acceptate.",
    "15. Preț: Articolul nu este eligibil deoarece prețul propus nu corespunde cu evaluarea noastră sau cu cerințele actuale ale pieței de lux.",
    "16. Stare: Articolul nu este eligibil deoarece starea acestuia nu îndeplinește standardele de calitate necesare pentru acceptarea în consignatie.",
  ];

  const handleOpenPopup = (action = "totalRefuse") => {
    setPendingRefuseAction(action);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setSelectedReason("");
    setDetails("");
    setPendingRefuseAction("totalRefuse");
  };

  const handleReasonChange = (reason) => {
    setSelectedReason(reason);
    setDetails(reason); // Copiază motivul în câmpul Detalii suplimentare
  };

  const syncRefuseToAppLuxura = async ({ refuseReason, statusLabel }) => {
    const effectiveSummary = (newSummary || summary || "").trim();
    const productId = extractEntryIdFromSummary(effectiveSummary);

    if (!productId) {
      return {
        skipped: true,
        reason: "missing_product_id",
      };
    }

    const response = await axios.post(
      buildStatusApiUrl("/api/tasks/mobile/refuse-sync"),
      {
        issueId,
        summary: effectiveSummary,
        productId,
        status: statusLabel,
        refuseReason,
      },
      {
        timeout: 10000,
      }
    );

    return {
      skipped: false,
      productId,
      response: response.data || null,
    };
  };

  const syncStartQualityCheckToAppLuxura = async () => {
    const effectiveSummary = (newSummary || summary || "").trim();
    const productId = extractEntryIdFromSummary(effectiveSummary);

    const response = await axios.post(
      buildStatusApiUrl("/api/tasks/mobile/start-quality-check-sync"),
      {
        issueId,
        summary: effectiveSummary,
        productId,
        note: "Produs primit pentru autentificare",
      },
      {
        timeout: 15000,
      }
    );

    return {
      productId,
      response: response.data || null,
    };
  };

  const syncAcceptToAppLuxura = async () => {
    const acceptSyncUrl = buildStatusApiUrl("/api/tasks/mobile/accept-sync");
    const payload = buildAcceptSyncPayload();

    console.log("[TaskEdit][AppLuxura accept-sync] Preparing request", {
      acceptSyncUrl,
      statusApiBase: STATUS_API_BASE,
      payload,
    });

    try {
      console.log("[TaskEdit][AppLuxura accept-sync] Sending request to backend", {
        acceptSyncUrl,
        productId: payload.productId,
        adminAmount: payload.adminAmount,
        acquisitionType: payload.acquisitionType,
      });

      const response = await axios.post(acceptSyncUrl, payload, {
        timeout: 15000,
      });

      console.log("[TaskEdit][AppLuxura accept-sync] Backend response", {
        status: response.status,
        data: response.data || null,
      });

      return {
        productId: payload.productId,
        response: response.data || null,
      };
    } catch (error) {
      console.error("[TaskEdit][AppLuxura accept-sync] Backend request failed", {
        acceptSyncUrl,
        productId: payload.productId,
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
      throw error;
    }
  };

  const executeRefuseFlow = async (actionType) => {
    const reasonText = details.trim();
    if (!reasonText) {
      alert("Vă rugăm să completați detaliile refuzului.");
      return;
    }

    const refuseConfigMap = {
      refuse: {
        transitionName: "Refuzat",
        jiraCustomField: "customfield_10161",
        jiraOptionLabel: "Da",
        appLuxuraStatus: "Refuzat",
      },
      totalRefuse: {
        transitionName: "Refuzat",
        jiraCustomField: "customfield_10160",
        jiraOptionLabel: "Da",
        appLuxuraStatus: "Refuzat",
      },
    };

    const refuseConfig =
      refuseConfigMap[actionType] || refuseConfigMap.totalRefuse;
    const transition = transitions.find(
      (t) => t.name === refuseConfig.transitionName
    );

    if (!transition) {
      const message = `No transition found for status "${refuseConfig.transitionName}"`;
      setError(message);
      showStatusError(`Nu există tranziția către "${refuseConfig.transitionName}".`);
      return;
    }

    try {
      await axios.put(
        buildStatusApiUrl(`/api/tasks/jira-task/${issueId}`),
        {
          customfield_10193: reasonText,
        }
      );

      if (refuseConfig.jiraCustomField) {
        const customFieldOptionsResponse = await axios.get(
          buildStatusApiUrl(
            `/api/tasks/jira-custom-field-options/${refuseConfig.jiraCustomField}`
          )
        );
        const option = customFieldOptionsResponse.data.find(
          (item) => item.label === refuseConfig.jiraOptionLabel
        );

        if (!option) {
          const message = `Option "${refuseConfig.jiraOptionLabel}" not found for custom field ${refuseConfig.jiraCustomField}`;
          setError(message);
          showStatusError(message);
          return;
        }

        await axios.post(
          buildStatusApiUrl("/api/tasks/jira-transition"),
          {
            issueId,
            transitionId: transition.id,
            customField: refuseConfig.jiraCustomField,
            customFieldValue: option.value,
          }
        );
      } else {
        await axios.post(
          buildStatusApiUrl("/api/tasks/jira-transition"),
          {
            issueId,
            transitionId: transition.id,
          }
        );
      }

      await syncRefuseToAppLuxura({
        refuseReason: reasonText,
        statusLabel: refuseConfig.appLuxuraStatus,
      });

      completeSuccessfulTransition(refuseConfig.transitionName);
      handleClosePopup();
    } catch (error) {
      console.error("There was an error performing the refusal flow!", error);
      const message = getStatusErrorMessage(
        error,
        "There was an error performing the refusal flow!"
      );
      setError(message);
      showStatusError(message);
    }
  };

  const handleSaveRefuse = async () => {
    await executeRefuseFlow(pendingRefuseAction);
  };
  // Helper pentru extragerea „Condiție” și „Dețin”
  const extractTagsAndDetails = (description = "") => {
    const normalized = description.replace(/\u00a0/g, " ");
    const condMatch = normalized.match(/Conditie\s+([\s\S]*?)(?=Model)/i);
    const condition = condMatch
      ? condMatch[1].trim().split(/\s+/)[0] || "N/A"
      : "N/A";
    const detinMatch = normalized.match(/Dețin\s*([\s\S]*?)Prețul cerut/i);
    let detin = detinMatch
      ? detinMatch[1]
          .split("*")
          .map((s) => s.trim())
          .filter(Boolean)
      : [];
    if (!detin.length) detin = ["Nimic"];
    return { condition, detin };
  };

  const extractTagsAndPrice = (description) => {
    const tagsMatch = description.match(
      /Dețin\s*([\s\S]*?)Prețul cerut\s*([\d\s.,]+)/i
    );
    if (tagsMatch) {
      const tagsString = tagsMatch[1];
      const mappedTags = [];

      const possibleTags = [
        "Cutie",
        "Dust bag",
        "Factura / Bon",
        "Factură",
        "Certificat",
      ];
      possibleTags.forEach((tag) => {
        const regex = new RegExp(`\\*?\\s*${tag}`, "i");
        if (regex.test(tagsString)) {
          mappedTags.push(tag.replace(" / Bon", "")); // normalize tag names
        }
      });

      if (mappedTags.length === 0) mappedTags.push("Nimic");

      // Extract and format the price
      let price = tagsMatch[2].trim();
      price = price.replace(/\s/g, "").replace(".", "").replace(",", ""); // Remove spaces, dots, and commas

      //setTags(mappedTags);
      setPrice(price);
    } else {
      setTags(["Nimic"]);
      setPrice(""); // Reset price if not found
    }
  };

  // ─── 1) FETCH DATE PRINCIPALE ────────────────────────────────────────
  useEffect(() => {
    const fetchCoreData = async () => {
      try {
        console.log("⏳ Fetching data for issueId:", issueId);

        // 1. Fetch task data
        const { data } = await axios.get(
          `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`
        );

        console.log("✅ Task data fetched:", data);

        // 2. Update basic state
        setTask(data);
        setSummary(data.summary || "");
        setNewSummary(data.summary || "");
        setStatus(data.status || "");
        setDescription(data.description || "");
        setEmail(data.email || "");
        setName(data.name || "");
        setPhone(data.phone || "");
        setUniqueId(data.uniqueId || "");

        // 3. Define dropdown field IDs
        const cfIds = [
          "customfield_10080", // Tip Achiziție
          "customfield_10183", // Luxura Policy
          "customfield_10173", // Categorie
          "customfield_10165", // Achizitor
          "customfield_10185", // Contactat
          "customfield_10099", // Alt dropdown
          "customfield_10337", // Stoc Extern
        ];

        // 4. Load dropdown options
        const opts = {};
        await Promise.all(
          cfIds.map(async (id) => {
            const resp = await axios.get(
              `https://server-9p4hx.kinsta.app/api/tasks/jira-custom-field-options/${id}`
            );
            opts[id] = resp.data;
            console.log(`🔸 Loaded options for ${id}:`, resp.data);
          })
        );

        setCustomFieldOptions(opts);

        // 5. Build new customFieldValues objectee
        const newCF = {
          customfield_10066: data.customfield_10066 || "",
          customfield_10083: data.customfield_10083 || "",
          customfield_10077: data.data_de_intrare || "",
          customfield_10072: data.customfield_10072 || "",
          customfield_10073: data.customfield_10073 || "",
          customfield_10078: data.expira_contract || "",
          customfield_10067: data.customfield_10067 || "",
          customfield_10069: data.customfield_10069 || "",
          customfield_10068: data.customfield_10068 || "",
          customfield_10186: data.customfield_10186 || "",
          customfield_10188: data.customfield_10188 || "",
          customfield_10181: data.customfield_10181 || "",
          customfield_10194: data.customfield_10194 || "",
          customfield_10195: data.customfield_10195 || "",
          customfield_10107: data.customfield_10107 || "",
          customfield_10070: data.customfield_10070 || "",
          customfield_10175: data.customfield_10175 || "",
          customfield_10176: data.customfield_10176 || "",
          customfield_10166: richTextFieldToPlainText(data.customfield_10166),
          customfield_10337: data.customfield_10337 || "",
        };

        const insotitLabels = Array.isArray(data.customfield_10099)
          ? data.customfield_10099
              .map((item) => (item && item.value ? item.value : ""))
              .filter(Boolean)
              .join(", ")
          : data.customfield_10099 && data.customfield_10099.value
            ? data.customfield_10099.value
            : "";

        // 6. Extract JIRA ids for dropdown fields
        cfIds.forEach((id) => {
          const raw = data[id];
          let jiraValue = "";

          if (id === "customfield_10099" && Array.isArray(raw)) {
            jiraValue = raw
              .map((item) => (item && item.id ? item.id.toString() : ""))
              .filter(Boolean)
              .join(",");
          } else if (raw && raw.id) {
            jiraValue = raw.id;
          } else if (raw && raw.value) {
            const matched = opts[id]?.find(
              (option) =>
                option.value === raw.value || option.label === raw.value
            );
            jiraValue = matched?.value || matched?.id || raw.value;
          } else if (Array.isArray(raw) && raw[0]?.id) {
            jiraValue = raw[0].id;
          } else if (typeof raw === "string") {
            jiraValue = raw;
          }

          newCF[id] = jiraValue ? jiraValue.toString() : "";
        });

        console.log("⚙️ new customFieldValues built:", newCF);
        setCustomFieldValues(newCF);

        // 7. Populate contractData fields using labels
        setContractData((prev) => ({
          ...prev,
          tipAchizitie:
            opts["customfield_10080"].find(
              (o) => o.value === newCF.customfield_10080
            )?.label || "",
          achizitor:
            opts["customfield_10165"].find(
              (o) => o.value === newCF.customfield_10165
            )?.label || "",
          contactat:
            opts["customfield_10185"].find(
              (o) => o.value === newCF.customfield_10185
            )?.label || "",
          checkboxOptions: insotitLabels,
        }));

        // 8. Extract condition and detin
        const { condition, detin } = extractTagsAndDetails(data.description);
        setTags(detin);
        setCustomFieldValues((prev) => ({ ...prev, condition }));

        // 9. Extract price tags
        extractTagsAndPrice(data.description);

        // 10. Load transitions
        const { data: trData } = await axios.get(
          buildStatusApiUrl(`/api/tasks/jira-transitions/${issueId}`)
        );
        setTransitions(trData);

        console.log("🚦 Transitions loaded:", trData);
        setError("");
      } catch (err) {
        console.error(`❌ fetchCoreData(${issueId}) failed:`, err);
        setError("There was an error fetching the task data!");
      }
    };

    if (issueId) {
      fetchCoreData();
    }
  }, [issueId]);

  // ─── 2) FETCH ATAȘAMENTE ───────────────────────────────────────────────
  useEffect(() => {
    const fetchAttachments = async () => {
      try {
        console.log("⏳ Fetching attachments for:", issueId);
        const res = await axios.get(
          buildApiUrl(`/api/tasks/jira-task/${issueId}`)
        );

        setAttachments(res.data.attachments || []);
        console.log("✅ Attachments fetched:", res.data.attachments);

        let firstImg = res.data.mainImageAttachment || null;

        if (!firstImg) {
          firstImg = (res.data.attachments || []).find((att) =>
            att.filename.includes("_master")
          );
        }

        if (!firstImg) {
          firstImg = (res.data.attachments || []).find((att) =>
            /\.(jpg|jpeg|png|gif|webp|heic|heif)$/i.test(att.filename)
          );
        }

        setFirstImageAttachment(firstImg || null);
      } catch (err) {
        console.error("❌ Error fetching attachments:", err);
      }
    };

    if (issueId) fetchAttachments();
  }, [issueId]);

  // după ce ai vendorData, customFieldValues, tipContract, selectedAddress
  // după ce ai vendorData, customFieldValues, tipContract, selectedAddress, name, phone, email, iban, bankName
  useEffect(() => {
    // sparge `name` în două părți
    const parts = name.trim().split(/\s+/);
    const firstName = parts[0] || "";
    const lastName = parts.slice(1).join(" ") || "";

    setContractData((prev) => ({
      ...prev,
      // ► date client
      nume: firstName,
      prenume: lastName,
      telefon: phone,
      email: email,

      // ► adresă (CI)
      adresa:
        prev.adresa ||
        selectedAddress?.address_line1 ||
        vendorData?.addresses?.find((a) => a.categorie === "ci")
          ?.address_line1 ||
        "",
      oras:
        prev.oras ||
        selectedAddress?.city ||
        vendorData?.addresses?.find((a) => a.categorie === "ci")?.city ||
        "",
      judet:
        prev.judet ||
        selectedAddress?.state ||
        vendorData?.addresses?.find((a) => a.categorie === "ci")?.state ||
        "",
      serieCI: prev.serieCI || vendorData?.vendor?.serieCI || "",
      nrCI: prev.nrCI || vendorData?.vendor?.nrCI || "",

      // ► date contract
      numarContract: customFieldValues.customfield_10066 || "",
      tipContract: tipContract || "",
      dataContract: customFieldValues.customfield_10077 || "",
      panaCand: customFieldValues.customfield_10078 || "",

      // ► valorile care nu populau
      pretCuvenit: customFieldValues.customfield_10181 || "",
      categoria: customFieldValues.customfield_10173 || "",
      brand: customFieldValues.customfield_10070 || "",
      model: customFieldValues.customfield_10107 || "",

      // ► detalii plată
      contCurent: iban,
      banca: bankName,
      pretFinalVanzare: customFieldValues.customfield_10195 || "",
      dataPlataFinalVanzare: customFieldValues.customfield_10194 || "",
    }));
  }, [
    name,
    phone,
    email,
    vendorData,
    selectedAddress,
    tipContract,

    // doar câmpurile necesare
    customFieldValues.customfield_10066, // nrContract
    customFieldValues.customfield_10077, // dataContract
    customFieldValues.customfield_10078, // panaCand
    customFieldValues.customfield_10181, // pretCuvenit
    customFieldValues.customfield_10173, // categoria
    customFieldValues.customfield_10070, // brand
    customFieldValues.customfield_10107, // model
    customFieldValues.customfield_10195, // pretFinalVanzare
    customFieldValues.customfield_10194, // dataPlataFinalVanzare

    iban,
    bankName,
  ]);

  // (Bloc duplicat de fetchAttachments eliminat sau păstrat dacă e necesar; păstrați doar unul dintre ele, cu logica nouă)

  const [awbData, setAwbData] = useState({
    street: "",
    number: "",
    postalCode: "",
    city: "",
    county: "",
    country: "Romania",
  });

  const handleAddressSelect = (address) => {
    setSelectedAddress(address); // Actualizează selectedAddress
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const taskResponse = await axios.get(
          `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`
        );
        const taskData = taskResponse.data;

        // Debugging pentru customfield_10077
        console.log(
          "Valoare customfield_10077 preluată din API:",
          taskData.customfield_10077
        );

        setCustomFieldValues((prevValues) => ({
          ...prevValues,
          customfield_10066: taskData.customfield_10066 || "N/A", // Nr Contract
          customfield_10181: taskData.customfield_10181 || "0", // Preț Final
          customfield_10077: taskData.customfield_10077 || "", // Data Intrare
        }));
      } catch (error) {
        console.error("Eroare la preluarea datelor task-ului:", error);
      }
    };

    fetchData();
  }, [issueId]);

  useEffect(() => {
    const fetchHistory = async () => {
      if (email) {
        setIsLoadingHistory(true);
        try {
          const historyResponse = await axios.get(
            `https://server-9p4hx.kinsta.app/api/tasks/tasks-by-email?email=${email}`
          );
          setHistory(historyResponse.data);
        } catch (error) {
          console.error("There was an error fetching the task history!", error);
        } finally {
          setIsLoadingHistory(false);
        }
      }
    };

    fetchHistory();
  }, [email]);

  useEffect(() => {
    const fetchScheduledAwb = async () => {
      try {
        const response = await axios.get(
          `https://server-9p4hx.kinsta.app/api/tasks/scheduled-awb/${issueId}`
        );
        if (response.data) {
          setScheduledAwb(response.data);
        }
      } catch (error) {
        console.error("There was an error fetching the scheduled AWB!", error);
      }
    };

    if (tab === "acceptat") {
      fetchScheduledAwb();
    }
  }, [issueId, tab]);

  // Resetarea ferestrei atunci când un alt task este selectat
  useEffect(() => {
    setTask({});
    setStatus("");
    setSummary("");
    setDescription("");
    setEmail("");
    setName("");
    setPhone("");
    setUniqueId("");
    setAttachments([]);
    setError("");
    setIsEditingSummary(false);
    setNewSummary("");
    setImageSearchResults([]);
    setFirstImageAttachment(null);
    setIsSearching(false);
    setTags([]);
    setPrice("");
    setExpandedHistory(false);
    setExpandedSearch(false);
    setTransitions([]);
    setSelectedTransition("");
    setCustomFieldOptions({});
    setCustomFieldValues({
      customfield_10066: "",
      customfield_10083: "",
      customfield_10077: "",
      customfield_10072: "",
      customfield_10073: "",
      customfield_10080: "",
      customfield_10183: "",
      customfield_10173: "",
      customfield_10078: "",
      customfield_10165: "",
      customfield_10185: "",
      customfield_10067: "",
      customfield_10069: "",
      customfield_10068: "",
      customfield_10186: "",
      customfield_10188: "",
      customfield_10181: "",
      customfield_10107: "",
      customfield_10070: "",
      customfield_10175: "",
      customfield_10176: "",
      customfield_10166: "",
      customfield_10337: "",
    });
    setHistory([]);
    setIsLoadingHistory(false);
    setStatusFeedback((prev) => ({ ...prev, open: false }));
    setScheduledAwb(null);

    // Reset contractData
    setContractData({
      nume: "",
      prenume: "",
      telefon: "",
      email: "",
      adresa: "",
      serieCI: "",
      nrCI: "",
      numarContract: "",
      tipContract: "",
    });
  }, [issueId]);

  useEffect(() => {
    if (showAnalysis) {
      document.body.style.overflow = "hidden"; // Blochează scroll-ul pe fundal
    } else {
      document.body.style.overflow = "auto"; // Reactivă scroll-ul pe fundal
    }

    // Curăță stilurile când componenta este demontată
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showAnalysis]);

  useEffect(() => {
    const fetchTaskDetails = async () => {
      try {
        const response = await axios.get(
          `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`
        );
        setStatus(response.data.status);
        const transitionsResponse = await axios.get(
          buildStatusApiUrl(`/api/tasks/jira-transitions/${issueId}`)
        );
        setTransitions(transitionsResponse.data);
      } catch (error) {
        console.error("There was an error fetching the task details!", error);
      }
    };

    fetchTaskDetails();
  }, [issueId]);

  // Acesta este useEffect-ul nou
  useEffect(() => {
    const fetchTaskDetails = async () => {
      try {
        const response = await axios.get(
          `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`
        );
        // Set task details including customfield_10188
        setCustomFieldValues((prevValues) => ({
          ...prevValues,
          customfield_10188: response.data.customfield_10188 || "", // Setăm customfield_10188
        }));
      } catch (error) {
        console.error("There was an error fetching the task details!", error);
      }
    };

    fetchTaskDetails();
  }, [issueId]);

  // Fetch task data
  useEffect(() => {
    const fetchTaskData = async () => {
      try {
        const response = await axios.get(
          `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`
        );
        const taskData = response.data;

        if (taskData.email && taskData.email.trim()) {
          setEmail(taskData.email.trim());
        } else {
          console.warn("No valid email found in task data.");
        }
      } catch (error) {
        console.error("Error fetching task data:", error);
      }
    };

    fetchTaskData();
  }, [issueId]);

  function completeSuccessfulTransition(newStatus) {
    setStatus(newStatus);
    const handledOptimistically =
      typeof onTaskTransition === "function" &&
      onTaskTransition({
        issueId,
        fromTab: currentTab,
        toStatus: newStatus,
      }) === true;

    if (handledOptimistically) {
      handlePanelClose();
      return;
    }

    showStatusUpdatedMessage();
  }

  function showStatusFeedback(severity, message) {
    setStatusFeedback({
      open: true,
      severity,
      message:
        message ||
        (severity === "success" ? STATUS_SUCCESS_MESSAGE : STATUS_ERROR_MESSAGE),
    });
  }

  function showStatusError(message) {
    showStatusFeedback("error", message || STATUS_ERROR_MESSAGE);
  }

  function getStatusErrorMessage(error, fallback = STATUS_ERROR_MESSAGE) {
    const responseData = error?.response?.data;
    if (typeof responseData === "string" && responseData.trim()) {
      return responseData;
    }
    return responseData?.message || responseData?.error || fallback;
  }

  function handleStatusFeedbackClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setStatusFeedback((prev) => ({ ...prev, open: false }));
  }

  const handleTransition = async (newStatus) => {
    const transition = transitions.find((t) => t.name === newStatus);
    if (!transition) {
      console.error(`No transition found for status "${newStatus}"`);
      showStatusError(`Nu există tranziția către "${newStatus}".`);
      return;
    }
    const transitionId = transition.id;

    try {
      await axios.post(buildStatusApiUrl("/api/tasks/jira-transition"), {
        issueId,
        transitionId,
      });

      completeSuccessfulTransition(newStatus);
    } catch (error) {
      console.error(
        `There was an error transitioning to "${newStatus}"!`,
        error
      );
      showStatusError(
        getStatusErrorMessage(
          error,
          `Nu am putut trece cererea în "${newStatus}".`
        )
      );
    }
  };

  const handleOnline = () => {
    handleTransition("ONLINE");
  };

  const handleRespins = () => {
    handleTransition("RESPINS");
  };

  const handleVandut = () => {
    const normalizedTarget = "vandut";
    const transition = transitions.find(
      (t) =>
        t?.name && t.name.toString().toLowerCase().includes(normalizedTarget)
    );
    if (!transition) {
      const message = 'No transition found for status "Vandut"';
      setError(message);
      showStatusError('Nu există tranziția către "Vandut".');
      return;
    }
    const transitionId = transition.id;
    axios
      .post(buildStatusApiUrl("/api/tasks/jira-transition"), {
        issueId,
        transitionId,
      })
      .then(() => {
        completeSuccessfulTransition(transition.name);
      })
      .catch((error) => {
        console.error("There was an error performing the transition!", error);
        const message = getStatusErrorMessage(
          error,
          "There was an error performing the transition!"
        );
        setError(message);
        showStatusError(message);
      });
  };

  const handleRefreshHistory = () => {
    setIsLoadingHistory(true);
    axios
      .get(
        `https://server-9p4hx.kinsta.app/api/tasks/tasks-by-email?email=${email}`
      )
      .then((response) => {
        setHistory(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the task history!", error);
      })
      .finally(() => {
        setIsLoadingHistory(false);
      });
  };

  const handleDeleteTag = (tagToDelete) => () => {
    setTags(tags.filter((tag) => tag !== tagToDelete));
  };

  const handleSave = () => {
    // Construim payload-ul doar cu valorile completate
    const fieldsToUpdate = {};
    const normalizeTag = (value) =>
      (value || "")
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

    const baseSummary = newSummary.trim() || summary || "";
    const cleanedSummary = baseSummary.replace(/\s*\[ext\]\s*$/i, "").trim();
    const shouldAppendExt = normalizeTag(stocExternLabel) === "da";
    const summaryWithExt =
      shouldAppendExt && cleanedSummary
        ? `${cleanedSummary} [EXT]`
        : cleanedSummary;

    if (summaryWithExt && summaryWithExt !== summary) {
      fieldsToUpdate.summary = summaryWithExt;
    } else if (newSummary.trim()) {
      fieldsToUpdate.summary = newSummary;
    }

    if (customFieldValues.customfield_10181) {
      fieldsToUpdate.customfield_10181 = customFieldValues.customfield_10181; // Preț Act
    }

    if (customFieldValues.customfield_10078) {
      fieldsToUpdate.customfield_10078 = customFieldValues.customfield_10078; // Expiră
    }

    if (customFieldValues.customfield_10072) {
      fieldsToUpdate.customfield_10072 = parseFloat(
        customFieldValues.customfield_10072
      ); // Preț Intrare
    }

    if (customFieldValues.customfield_10073) {
      fieldsToUpdate.customfield_10073 = parseFloat(
        customFieldValues.customfield_10073
      ); // Preț Vânzare
    }

    if (name.trim()) {
      fieldsToUpdate.customfield_10067 = name; // Mapare Nume
    }

    if (email.trim()) {
      fieldsToUpdate.customfield_10069 = email; // Mapare Email
    }

    if (phone.trim()) {
      fieldsToUpdate.customfield_10068 = phone; // Mapare Telefon
    }

    if (customFieldValues.customfield_10186) {
      fieldsToUpdate.customfield_10186 = customFieldValues.customfield_10186; // Notă internă
    }
    if (customFieldValues.customfield_10175) {
      fieldsToUpdate.customfield_10175 = customFieldValues.customfield_10175; // Banca
    }
    if (customFieldValues.customfield_10176) {
      fieldsToUpdate.customfield_10176 = customFieldValues.customfield_10176; // IBAN
    }
    if (customFieldValues.customfield_10166) {
      fieldsToUpdate.customfield_10166 = plainTextToRichTextField(
        customFieldValues.customfield_10166
      ); // Adresa
    }

    if (customFieldValues.customfield_10183) {
      fieldsToUpdate.customfield_10183 = customFieldValues.customfield_10183; // Luxura Policy
    }

    if (customFieldValues.customfield_10080) {
      fieldsToUpdate.customfield_10080 = customFieldValues.customfield_10080; // Tip Achiziție
    }
    const resolveSingleSelectId = (fieldId, selectedValue) => {
      if (
        selectedValue === undefined ||
        selectedValue === null ||
        selectedValue === ""
      ) {
        return "";
      }
      const options = Array.isArray(customFieldOptions[fieldId])
        ? customFieldOptions[fieldId]
        : [];
      const matched = options.find(
        (option) =>
          String(option.value) === String(selectedValue) ||
          normalizeTag(option.label) === normalizeTag(selectedValue)
      );
      return matched?.value || matched?.id || selectedValue;
    };

    const stocExternValue = resolveSingleSelectId(
      "customfield_10337",
      customFieldValues.customfield_10337
    );
    if (stocExternValue) {
      fieldsToUpdate.customfield_10337 = stocExternValue; // Stoc Extern
    }

    if (customFieldValues.customfield_10077) {
      fieldsToUpdate.customfield_10077 = customFieldValues.customfield_10077; // Data Intrare
    }

    if (customFieldValues.customfield_10173) {
      fieldsToUpdate.customfield_10173 = customFieldValues.customfield_10173; // Categorie
    }

    if (customFieldValues.customfield_10165) {
      fieldsToUpdate.customfield_10165 = customFieldValues.customfield_10165; // Achizitor
    }

    if (customFieldValues.customfield_10185) {
      fieldsToUpdate.customfield_10185 = customFieldValues.customfield_10185; // Contactat
    }

    if (customFieldValues.customfield_10070) {
      fieldsToUpdate.customfield_10070 = customFieldValues.customfield_10070; // Brand
    }

    if (customFieldValues.customfield_10107) {
      fieldsToUpdate.customfield_10107 = customFieldValues.customfield_10107; // Model
    }

    if (customFieldValues.customfield_10066) {
      fieldsToUpdate.customfield_10066 = customFieldValues.customfield_10066; // Nr Jurnal
    }

    if (Array.isArray(tags)) {
      const insotitOptions = Array.isArray(customFieldOptions.customfield_10099)
        ? customFieldOptions.customfield_10099
        : [];
      const mappedTags = tags
        .map((tag) => {
          const tagKey = normalizeTag(tag);
          const option = insotitOptions.find(
            (opt) => normalizeTag(opt.label) === tagKey
          );
          return option?.value ? { id: option.value } : null;
        })
        .filter(Boolean);

      if (mappedTags.length > 0) {
        fieldsToUpdate.customfield_10099 = mappedTags; // Vine insotit
      } else if (tags.length === 0) {
        fieldsToUpdate.customfield_10099 = [];
      } else {
        console.warn(
          "[TaskEdit] Nu am gasit optiuni valide pentru customfield_10099:",
          tags
        );
      }
    }

    // Efectuăm apelul API doar dacă există câmpuri de actualizat
    if (Object.keys(fieldsToUpdate).length > 0) {
      axios
        .put(
          `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`,
          fieldsToUpdate
        )
        .then(() => {
          setSummary(newSummary);
          alert("Modificările au fost salvate cu succes!");
        })
        .catch((error) => {
          console.error("There was an error updating the task!", error);
          setError("There was an error updating the task!");
        });
    } else {
      alert("Nu există câmpuri completate pentru a fi salvate.");
    }
  };

  const handleSaveSummary = () => {
    axios
      .put(`https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`, {
        summary: newSummary,
      })
      .then(() => {
        setSummary(newSummary);
        setIsEditingSummary(false);
      })
      .catch((error) => {
        console.error("There was an error updating the summary!", error);
        setError("There was an error updating the summary!");
      });
  };

  const handleSaveName = () => {
    axios
      .put(`https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`, {
        customfield_10067: name,
      })
      .then(() => {
        // Update name in state
      })
      .catch((error) => {
        console.error("There was an error updating the name!", error);
        setError("There was an error updating the name!");
      });
  };

  const handleSavePhone = () => {
    axios
      .put(`https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`, {
        customfield_10068: phone,
      })
      .then(() => {
        // Update phone in state
      })
      .catch((error) => {
        console.error("There was an error updating the phone!", error);
        setError("There was an error updating the phone!");
      });
  };

  const handleSaveEmail = () => {
    axios
      .put(`https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`, {
        customfield_10069: email,
      })
      .then(() => {
        // Update email in state
      })
      .catch((error) => {
        console.error("There was an error updating the email!", error);
        setError("There was an error updating the email!");
      });
  };

  const handleAttachmentClick = (attachmentUrl) => {
    window.open(attachmentUrl, "_blank");
  };

  const getAttachmentImageUrl = (attachmentId) =>
    buildApiUrl(`/api/tasks/attachments/${attachmentId}`);

  const isPointOverMainImage = (clientX, clientY) => {
    const rect = mainImageDropRef.current?.getBoundingClientRect();
    if (!rect) {
      return false;
    }

    return (
      clientX >= rect.left &&
      clientX <= rect.right &&
      clientY >= rect.top &&
      clientY <= rect.bottom
    );
  };

  const applyMainImageAttachment = async (attachment) => {
    if (!attachment?.id) {
      alert("Nu am putut salva imaginea principală: attachmentId lipsă.");
      return;
    }

    if (String(attachment.id) === String(firstImageAttachment?.id)) {
      return;
    }

    setFirstImageAttachment(attachment);
    setAttachments((prev) => [
      attachment,
      ...prev.filter((att) => String(att?.id || "") !== String(attachment.id)),
    ]);

    try {
      await axios.put(
        buildApiUrl(`/api/tasks/jira-task/${issueId}/main-image`),
        { attachmentId: attachment.id, attachment }
      );
    } catch (error) {
      const status = error?.response?.status || "fără status";
      const responseError =
        error?.response?.data?.error ||
        error?.response?.data?.details ||
        error?.message ||
        "eroare necunoscută";
      const endpoint = buildApiUrl(`/api/tasks/jira-task/${issueId}/main-image`);
      console.error("Nu am putut salva imaginea principală:", {
        endpoint,
        status,
        response: error?.response?.data,
        attachment,
      });
      alert(
        `Nu am putut salva imaginea principală.\nEndpoint: ${endpoint}\nStatus: ${status}\nEroare: ${responseError}`
      );
      try {
        const res = await axios.get(buildApiUrl(`/api/tasks/jira-task/${issueId}`));
        setAttachments(res.data.attachments || []);
        setFirstImageAttachment(res.data.mainImageAttachment || null);
      } catch (reloadError) {
        console.error("Nu am putut reîncărca atașamentele:", reloadError);
      }
    }
  };

  const handleSummaryClick = () => {
    setIsEditingSummary(true);
  };

  const handleSummaryChange = (event) => {
    setNewSummary(event.target.value);
  };

  const handleSummaryBlur = () => {
    handleSaveSummary();
  };

  const getPdfAttachmentKeyword = (filename = "") => {
    const normalized = String(filename || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[_-]+/g, " ");

    const rules = [
      { label: "QC", patterns: [/\bqc\b/, /quality\s*check/, /raport\s*qc/] },
      { label: "Contract", patterns: [/\bcontract\b/] },
      { label: "Fisa", patterns: [/\bfisa\b/, /cerere\s+oferta/, /\bconsignatie\b/] },
      { label: "AWB", patterns: [/\bawb\b/] },
      { label: "Factura", patterns: [/\bfactura\b/, /\binvoice\b/] },
      { label: "Retur", patterns: [/\bretur\b/] },
      { label: "Refuz", patterns: [/\brefuz\b/] },
      { label: "Act", patterns: [/act\s+aditional/, /\baditional\b/, /\bdiminuare\b/] },
      { label: "Plata", patterns: [/\bplata\b/, /\bpayment\b/] },
      { label: "Nota", patterns: [/\bnota\b/] },
    ];

    const match = rules.find((rule) =>
      rule.patterns.some((pattern) => pattern.test(normalized))
    );

    return match?.label || "PDF";
  };

  const renderAttachmentPreview = (attachment) => {
    const fileExtension = attachment.filename.split(".").pop().toLowerCase();
    const commonImageTypes = ["jpg", "jpeg", "png", "gif", "webp", "heic", "heif"];
    const isImage = commonImageTypes.includes(fileExtension);
    const isPDF = fileExtension === "pdf";
    const attachmentUrl = getAttachmentImageUrl(attachment.id);
    const pdfKeyword = isPDF ? getPdfAttachmentKeyword(attachment.filename) : "";

    if (isImage) {
      return (
        <Box
          draggable={false}
          onDragStart={(e) => handleDragStart(e, attachment)}
          onDragEnd={() => setDraggedImageAttachment(null)}
          onPointerDown={(e) => handleThumbnailPointerDown(e, attachment)}
          onPointerMove={handleThumbnailPointerMove}
          onPointerUp={handleThumbnailPointerUp}
          onPointerCancel={handleThumbnailPointerCancel}
          onClick={(e) => {
            if (pointerDragClickGuardRef.current) {
              e.preventDefault();
              e.stopPropagation();
              pointerDragClickGuardRef.current = false;
              return;
            }

            handleAttachmentClick(attachmentUrl);
          }}
          sx={{
            width: 72,
            height: 72,
            mr: 1.25,
            p: 0.5,
            borderRadius: 1.5,
            border: "1px solid rgba(30, 144, 255, 0.25)",
            bgcolor: "rgba(30, 144, 255, 0.06)",
            cursor: "grab",
            userSelect: "none",
            touchAction: "none",
            transition: "transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease",
            "&:active": { cursor: "grabbing" },
            "&:hover": {
              transform: "translateY(-1px)",
              borderColor: "#1E90FF",
              boxShadow: "0 8px 18px rgba(30, 144, 255, 0.18)",
            },
          }}
          title="Trage imaginea peste poza principală"
        >
          <img
            src={attachmentUrl}
            alt={attachment.filename}
            draggable={false}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              objectFit: "cover",
              display: "block",
              pointerEvents: "none",
            }}
          />
        </Box>
      );
    } else if (isPDF) {
      return (
        <Box
          onClick={() => handleAttachmentClick(attachmentUrl)}
          title={attachment.filename}
          sx={{
            width: 82,
            mr: 1.25,
            p: 0.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 1.5,
            cursor: "pointer",
            userSelect: "none",
            transition: "transform 140ms ease, box-shadow 140ms ease, background-color 140ms ease",
            "&:hover": {
              transform: "translateY(-1px)",
              bgcolor: "rgba(30, 144, 255, 0.06)",
              boxShadow: "0 8px 18px rgba(15, 23, 42, 0.12)",
            },
          }}
        >
          <img
            src={PdfIcon}
            alt={attachment.filename}
            draggable={false}
            style={{
              width: "64px",
              height: "64px",
              display: "block",
            }}
          />
          <Typography
            component="span"
            variant="caption"
            sx={{
              mt: 0.5,
              px: 0.75,
              py: 0.25,
              maxWidth: "100%",
              borderRadius: "999px",
              bgcolor: "rgba(15, 23, 42, 0.08)",
              color: "#334155",
              fontSize: 11,
              lineHeight: 1.2,
              fontWeight: 700,
              textAlign: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {pdfKeyword}
          </Typography>
        </Box>
      );
    }
    return null;
  };

  const handleDragStart = (e, attachment) => {
    const payload = JSON.stringify(attachment);
    setDraggedImageAttachment(attachment);
    e.dataTransfer.setData("attachment", payload);
    e.dataTransfer.setData("application/json", payload);
    e.dataTransfer.setData("text/plain", payload);
    e.dataTransfer.effectAllowed = "move";
    if (e.currentTarget) {
      e.dataTransfer.setDragImage(e.currentTarget, 36, 36);
    }
  };

  const resetPointerImageDrag = () => {
    pointerImageDragRef.current = null;
    setPointerDragPreview(null);
    setIsMainImageDragOver(false);
  };

  const handleThumbnailPointerDown = (e, attachment) => {
    if (e.pointerType === "mouse" && e.button !== 0) {
      return;
    }

    pointerImageDragRef.current = {
      attachment,
      pointerId: e.pointerId,
      startX: e.clientX,
      startY: e.clientY,
      isDragging: false,
    };

    try {
      e.currentTarget.setPointerCapture(e.pointerId);
    } catch (error) {
      console.warn("Nu am putut activa pointer capture pentru imagine:", error);
    }
  };

  const handleThumbnailPointerMove = (e) => {
    const dragState = pointerImageDragRef.current;
    if (!dragState || dragState.pointerId !== e.pointerId) {
      return;
    }

    const moveDistance = Math.hypot(
      e.clientX - dragState.startX,
      e.clientY - dragState.startY
    );

    if (!dragState.isDragging && moveDistance < 6) {
      return;
    }

    dragState.isDragging = true;
    pointerDragClickGuardRef.current = true;
    e.preventDefault();
    e.stopPropagation();

    setPointerDragPreview({
      attachment: dragState.attachment,
      x: e.clientX,
      y: e.clientY,
    });
    setIsMainImageDragOver(isPointOverMainImage(e.clientX, e.clientY));
  };

  const handleThumbnailPointerUp = async (e) => {
    const dragState = pointerImageDragRef.current;
    if (!dragState || dragState.pointerId !== e.pointerId) {
      return;
    }

    try {
      e.currentTarget.releasePointerCapture(e.pointerId);
    } catch (error) {
      console.warn("Nu am putut elibera pointer capture pentru imagine:", error);
    }

    const shouldApplyImage =
      dragState.isDragging && isPointOverMainImage(e.clientX, e.clientY);
    const draggedAttachment = dragState.attachment;

    if (dragState.isDragging) {
      e.preventDefault();
      e.stopPropagation();
      pointerDragClickGuardRef.current = true;
    }

    resetPointerImageDrag();

    if (dragState.isDragging) {
      window.setTimeout(() => {
        pointerDragClickGuardRef.current = false;
      }, 120);
    }

    if (shouldApplyImage) {
      await applyMainImageAttachment(draggedAttachment);
    }
  };

  const handleThumbnailPointerCancel = () => {
    resetPointerImageDrag();
    window.setTimeout(() => {
      pointerDragClickGuardRef.current = false;
    }, 80);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMainImageDragOver(false);

    let attachment = null;
    try {
      const rawPayload =
        e.dataTransfer.getData("application/json") ||
        e.dataTransfer.getData("text/plain") ||
        e.dataTransfer.getData("attachment");
      attachment = rawPayload ? JSON.parse(rawPayload) : draggedImageAttachment;
    } catch (error) {
      console.warn("Nu am putut citi attachment-ul tras:", error);
      attachment = draggedImageAttachment;
    }
    setDraggedImageAttachment(null);

    await applyMainImageAttachment(attachment);
  };

  const uploadImage = (imageFile) => {
    const formData = new FormData();
    formData.append("image", imageFile);

    return axios.post(
      buildApiUrl("/api/tasks/upload-image"),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  };

  const handleImageSearch = () => {
    setIsSearching(true); // Set searching state to true when starting the search

    if (firstImageAttachment) {
      const imageUrl = buildApiUrl(
        `/api/tasks/attachments/${firstImageAttachment.id}`
      );
      axios
        .get(imageUrl, { responseType: "blob" })
        .then((response) => {
          const imageFile = new File(
            [response.data],
            firstImageAttachment.filename
          );
          return uploadImage(imageFile);
        })
        .then((uploadResponse) => {
          const imageUrl = uploadResponse.data.imageUrl;
          console.log(`Image URL uploaded: ${imageUrl}`);
          return axios.post(
            buildApiUrl("/api/tasks/search-image"),
            {
              imageUrl,
            }
          );
        })
        .then((searchResponse) => {
          setImageSearchResults(searchResponse.data.results);
          setExpandedSearch(true); // Expand the accordion when search results are available
        })
        .catch((error) => {
          console.error("There was an error searching the image!", error);
        })
        .finally(() => {
          setIsSearching(false); // Set searching state to false when the search is complete
        });
    } else {
      console.error("No image attachment found!");
      setIsSearching(false);
    }
  };

  const handleAccept = async () => {
    // Verificăm dacă suntem în tab-ul "CREATED"
    if (tab === "created") {
      const transition = transitions.find((t) => t.name === "PROSPECT");
      if (!transition) {
        const message = 'No transition found for status "PROSPECT"';
        setError(message);
        showStatusError('Nu există tranziția către "PROSPECT".');
        return;
      }
      const transitionId = transition.id;

      try {
        // Tranziționăm taskul la statusul "PROSPECT"
        await axios.post(buildStatusApiUrl("/api/tasks/jira-transition"), {
          issueId,
          transitionId,
        });

        completeSuccessfulTransition("PROSPECT"); // Setăm noul status la "PROSPECT"
      } catch (error) {
        console.error('There was an error transitioning to "PROSPECT"!', error);
        const message = getStatusErrorMessage(
          error,
          'There was an error transitioning to "PROSPECT"!'
        );
        setError(message);
        showStatusError(message);
      }
    } else if (tab === "prospect") {
      // Tranziționăm la "ACCEPTAT" dacă suntem deja în "PROSPECT"
      const transition = transitions.find((t) => t.name === "ACCEPTAT");
      if (!transition) {
        const message = 'No transition found for status "ACCEPTAT"';
        setError(message);
        showStatusError('Nu există tranziția către "ACCEPTAT".');
        return;
      }
      const transitionId = transition.id;

      try {
        try {
          buildAcceptSyncPayload();
        } catch (validationError) {
          console.error("[TaskEdit][Acceptat] AppLuxura payload invalid", {
            issueId,
            message: validationError.message,
          });
          setError(validationError.message);
          showStatusError(validationError.message);
          setAlertMessage(validationError.message);
          setAlertType("error");
          setShowAlert(true);
          return;
        }

        console.log("[TaskEdit][Acceptat] Button pressed / transition start", {
          issueId,
          tab,
          transitionId,
          summary,
        });

        // Tranziționăm taskul la statusul "ACCEPTAT"
        await axios.post(buildStatusApiUrl("/api/tasks/jira-transition"), {
          issueId,
          transitionId,
        });

        console.log("[TaskEdit][Acceptat] Jira transition completed", {
          issueId,
          transitionId,
        });

        setStatus("ACCEPTAT"); // Setăm noul status la "ACCEPTAT"

        try {
          console.log("[TaskEdit][Acceptat] Calling AppLuxura accept sync", {
            issueId,
            tab,
          });
          const acceptSyncResult = await syncAcceptToAppLuxura();
          console.log("[TaskEdit][Acceptat] AppLuxura accept sync completed", {
            issueId,
            result: acceptSyncResult,
          });
        } catch (syncError) {
          console.error("[TaskEdit][Acceptat] AppLuxura accept sync failed", {
            message: syncError.message,
            status: syncError.response?.status,
            data: syncError.response?.data,
          });
        }

        try {
          // Trimiterea SMS-ului doar dacă ne aflăm în tab-ul "PROSPECT"
          await axios.post(
            buildStatusApiUrl("/api/tasks/send-acceptance-sms"),
            {
              contactName: name,
              contactPhone: phone,
              summary,
              entryPrice: customFieldValues.customfield_10072, // Prețul de intrare
            }
          );
        } catch (smsError) {
          console.error("There was an error sending the SMS!", smsError);
          // Ignorăm eroarea de la SMS și continuăm
        }

        completeSuccessfulTransition("ACCEPTAT");
      } catch (error) {
        console.error("There was an error performing the transition!", error);
        const message = getStatusErrorMessage(
          error,
          "There was an error performing the transition!"
        );
        setError(message);
        showStatusError(message);
      }
    }
  };

  // Adăugăm funcția handleTransit
  const handleTransit = () => {
    const transition = transitions.find((t) => t.name === "TRANZIT");
    if (!transition) {
      const message = 'No transition found for status "TRANZIT"';
      setError(message);
      showStatusError('Nu există tranziția către "TRANZIT".');
      return;
    }
    const transitionId = transition.id;
    axios
      .post(buildStatusApiUrl("/api/tasks/jira-transition"), {
        issueId,
        transitionId,
      })
      .then(() => {
        completeSuccessfulTransition("TRANZIT");
      })
      .catch((error) => {
        console.error("There was an error performing the transition!", error);
        const message = getStatusErrorMessage(
          error,
          "There was an error performing the transition!"
        );
        setError(message);
        showStatusError(message);
      });
  };

  // Funcție nouă pentru gestionarea clicului pe butonul "AUTENTIFICARE"
  const handleAutentificare = async () => {
    const normalizeTransition = (value = "") =>
      value
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    const transition = transitions.find((t) =>
      normalizeTransition(t.name).includes("autentificare")
    );
    if (!transition) {
      const message = 'No transition found for status "AUTENTIFICARE"';
      setError(message);
      showStatusError('Nu există tranziția către "AUTENTIFICARE".');
      return;
    }
    const transitionId = transition.id;

    try {
      if (stocExternLabel !== "da") {
        // Apelăm endpointul pentru a trimite emailul de confirmare
        await axios.post(
          buildStatusApiUrl("/api/tasks/send-authentication-email"),
          {
            issueId,
            summary,
            contactName: name,
            contactEmail: email,
          }
        );

        // Apelăm endpointul pentru a trimite SMS-ul de confirmare
        await axios.post(
          buildStatusApiUrl("/api/tasks/send-authentication-sms"),
          {
            contactName: name,
            contactPhone: phone,
            summary,
          }
        );
      } else {
        await axios.post(
          buildStatusApiUrl("/api/tasks/log-auth-skip"),
          {
            issueId,
            summary,
            reason: "stoc extern",
          }
        );
      }

      // Tranziționăm taskul la statusul "AUTENTIFICARE"
      await axios.post(buildStatusApiUrl("/api/tasks/jira-transition"), {
        issueId,
        transitionId,
      });

      try {
        await syncStartQualityCheckToAppLuxura();
      } catch (syncError) {
        console.error("AppLuxura start-quality-check sync failed:", {
          message: syncError.message,
          status: syncError.response?.status,
          data: syncError.response?.data,
        });
      }

      completeSuccessfulTransition("AUTENTIFICARE");
    } catch (error) {
      console.error("Autentificare transition failed:", {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
      console.error(
        "There was an error performing the transition or sending the email/SMS!",
        error
      );
      setError(
        stocExternLabel === "da"
          ? "There was an error performing the transition!"
          : "There was an error performing the transition or sending the email/SMS!"
      );
      showStatusError(
        getStatusErrorMessage(
          error,
          stocExternLabel === "da"
            ? "There was an error performing the transition!"
            : "There was an error performing the transition or sending the email/SMS!"
        )
      );
    }
  };

  const handleRefuse = async () => {
    handleOpenPopup("refuse");
  };

  const handleTotalRefuse = async () => {
    handleOpenPopup("totalRefuse");
  };

  function showStatusUpdatedMessage() {
    showStatusFeedback("success", STATUS_SUCCESS_MESSAGE);
    if (statusMessageTimeoutRef.current) {
      clearTimeout(statusMessageTimeoutRef.current);
    }
    statusMessageTimeoutRef.current = setTimeout(() => {
      setStatusFeedback((prev) => ({ ...prev, open: false }));
      if (typeof onClose === "function") {
        onClose();
      }
      if (typeof reloadTasks === "function") {
        reloadTasks();
      }
      statusMessageTimeoutRef.current = null;
    }, 2000);
  }

  useEffect(() => {
    return () => {
      if (statusMessageTimeoutRef.current) {
        clearTimeout(statusMessageTimeoutRef.current);
        statusMessageTimeoutRef.current = null;
      }
    };
  }, []);

  const handleCustomFieldChange = (field, value) => {
    setCustomFieldValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  // Funcție pentru a gestiona clicul pe butonul de analiză
  const handleAnalysisClick = () => {
    setManualAvgPrice(customFieldValues.customfield_10073); // Setăm manualAvgPrice în TaskEdit
    setShowAnalysis(true);
  };

  // Funcție pentru a reveni din pagina de analiză
  const handleBackFromAnalysis = () => {
    setShowAnalysis(false);
  };

  // Funcție pentru a seta manualAvgPrice (va fi apelată când se schimbă Prețul de Vânzare)
  const handleManualAvgPriceChange = (price) => {
    setManualAvgPrice(price);
  };

  // Funcție pentru clonarea produsului cu imagine
  const cloneProductWithImage = async (productId) => {
    const formData = new FormData();
    formData.append("productId", productId);
    formData.append("issueId", issueId);
    if (firstImageAttachment?.id) {
      formData.append("attachmentId", firstImageAttachment.id);
    }

    let selectedImage = firstImageAttachment;

    if (!selectedImage) {
      selectedImage = attachments.find((att) =>
        /\.(jpg|jpeg|png|gif|webp|heic|heif)$/i.test(att.filename)
      );
    }

    if (selectedImage?.id) {
      const imageResponse = await axios.get(
        buildApiUrl(`/api/tasks/attachments/${selectedImage.id}`),
        { responseType: "arraybuffer" }
      );
      const imageBlob = new Blob([imageResponse.data], { type: "image/jpeg" });
      formData.append("image", imageBlob, "featured.jpg");
    }

    const response = await axios.post(
      buildApiUrl("/api/masterdata/clone-product-by-id"),
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;
  };

  const LoadingAnimation = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        color: "#1E90FF",
        marginTop: "20px",
      }}
    >
      <CircularProgress size={60} sx={{ color: "#6a0dad" }} />
      <Typography variant="h6" sx={{ marginTop: "20px", color: "#6a0dad" }}>
        Loading history...
      </Typography>
    </Box>
  );

  const renderHistory = () => {
    const groupedHistory = history.reduce((acc, item) => {
      if (!acc[item.status]) acc[item.status] = [];
      acc[item.status].push(item);
      return acc;
    }, {});
    return (
      <Box sx={{ marginBottom: "20px" }}>
        <Accordion
          sx={{ boxShadow: "none", border: "none" }}
          expanded={expandedHistory}
          onChange={() => setExpandedHistory(!expandedHistory)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "0 16px",
            }}
          >
            <DocIcon style={{ marginRight: "16px" }} />
            <Typography
              variant="h6"
              component="h3"
              sx={{ fontWeight: "bold", color: "#6a0dad" }}
            >
              Istoric
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: "#fff", padding: "16px" }}>
            <Button
              variant="contained"
              startIcon={<RefreshIcon />}
              onClick={handleRefreshHistory}
              sx={{
                marginTop: "10px",
                backgroundColor: "#FFD700",
                "&:hover": {
                  backgroundColor: "#FFC700",
                },
                color: "#FF8C00",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "14px",
                fontWeight: "bold",
                textTransform: "none",
                height: "40px",
                borderRadius: "8px",
                width: "100%",
              }}
            >
              Refresh History
            </Button>

            {isLoadingHistory ? (
              <LoadingAnimation />
            ) : history.length === 0 ? (
              <Typography variant="body2" component="p">
                Nu există istoric disponibil.
              </Typography>
            ) : (
              Object.keys(groupedHistory).map((status) => (
                <Box key={status} sx={{ marginBottom: "20px" }}>
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{
                      fontWeight: "bold",
                      color: "#6a0dad",
                      marginBottom: "10px",
                    }}
                  >
                    {status}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#fff",
                      padding: "10px",
                      borderRadius: "8px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        padding: "8px 0",
                        borderBottom: "1px solid #ccc",
                      }}
                    >
                      <Typography
                        variant="body1"
                        component="p"
                        sx={{ flex: 1, fontWeight: "bold" }}
                      >
                        Denumire
                      </Typography>
                      <Typography
                        variant="body1"
                        component="p"
                        sx={{
                          flex: 1,
                          fontWeight: "bold",
                          padding: "0px 0px 0px 30px",
                        }}
                      >
                        Contract
                      </Typography>
                      <Typography
                        variant="body1"
                        component="p"
                        sx={{ flex: 1, fontWeight: "bold" }}
                      >
                        Data
                      </Typography>
                    </Box>
                    {groupedHistory[status].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          padding: "10px 0",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        <Typography
                          variant="body2"
                          component="p"
                          sx={{ flex: 1 }}
                        >
                          {item.summary}
                        </Typography>
                        <Typography
                          variant="body2"
                          component="p"
                          sx={{ flex: 1, padding: "0px 0px 0px 10px" }}
                        >
                          {item.tip_contract !== "N/A"
                            ? item.tip_contract
                            : item.tip_achizitie}
                        </Typography>
                        <Typography
                          variant="body2"
                          component="p"
                          sx={{ flex: 1 }}
                        >
                          {new Date(item.data_de_intrare).toLocaleDateString()}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              ))
            )}
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  };

  const handleContractInputChange = (e) => {
    const { name, value } = e.target;
    setContractData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleIdCardParsed = async (data) => {
    if (!data) return;
    setContractData((prevData) => ({
      ...prevData,
      adresa: data.adresa || prevData.adresa,
      oras: data.oras || prevData.oras,
      judet: data.judet || prevData.judet,
      serieCI: data.serieCI || prevData.serieCI,
      nrCI: data.nrCI || prevData.nrCI,
      eliberatDe: data.eliberatDe || prevData.eliberatDe,
      eliberatLaData: data.eliberatLaData || prevData.eliberatLaData,
    }));
    if (data.adresa) {
      setCustomFieldValues((prevValues) => ({
        ...prevValues,
        customfield_10166: data.adresa,
      }));
      if (issueId) {
        axios
          .put(
            `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`,
            {
              customfield_10166: data.adresa,
            }
          )
          .then(() => {
            console.log("[OCR] Adresa salvata in JIRA:", data.adresa, issueId);
          })
          .catch((error) => {
            console.error("[OCR] Eroare la salvarea adresei in JIRA:", error);
          });
      }
    }

    if (data.cnp || data.serieCI || data.nrCI) {
      const payload = {
        cnp: data.cnp || "",
        serieCI: data.serieCI || "",
        nrCI: data.nrCI || "",
      };
      const last = lastSavedConfidentialRef.current;
      const isSame =
        payload.cnp === last.cnp &&
        payload.serieCI === last.serieCI &&
        payload.nrCI === last.nrCI;

      if (!isSame) {
        try {
          let vendorId = vendorData?.vendor?.vendor_id;
          if (!vendorId && email) {
            const vendorResponse = await axios.get(
              `${API_BASE}/api/tasks/vendor/${email}`
            );
            vendorId = vendorResponse.data?.vendor?.vendor_id;
          }

          if (!vendorId) {
            console.warn("[OCR] Vendor ID lipsa pentru salvare confidentiala.");
            setOcrSaveMessage(
              "Nu am găsit vendorul pentru salvarea datelor din buletin."
            );
            setOcrSaveType("error");
            setShowOcrSaveAlert(true);
            return;
          }

          const dbPayload = {
            vendor_id: vendorId,
            ...payload,
          };
          await axios.post(
            `${API_BASE}/api/tasks/vendor/confidential-info`,
            dbPayload
          );
          lastSavedConfidentialRef.current = payload;
          setOcrSaveMessage("Datele din buletin au fost salvate cu succes.");
          setOcrSaveType("success");
          setShowOcrSaveAlert(true);
        } catch (error) {
          console.error("[OCR] Error saving confidential info:", {
            status: error.response?.status,
            message: error.message,
          });
          setOcrSaveMessage(
            error.response?.data?.message ||
              "Eroare la salvarea datelor din buletin. Încearcă din nou."
          );
          setOcrSaveType("error");
          setShowOcrSaveAlert(true);
        }
      }
    }
  };

  const handleSaveBankIban = () => {
    if (!issueId) return;

    const payload = {};
    if (customFieldValues.customfield_10175) {
      payload.customfield_10175 = customFieldValues.customfield_10175;
    }
    if (customFieldValues.customfield_10176) {
      payload.customfield_10176 = customFieldValues.customfield_10176;
    }

    if (Object.keys(payload).length === 0) {
      console.warn("[JIRA] Nimic de salvat pentru banca/IBAN.");
      return;
    }

    axios
      .put(
        `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`,
        payload
      )
      .then(() => {
        if (payload.customfield_10176) {
          lastSavedIbanRef.current = payload.customfield_10176;
        }
        if (payload.customfield_10175) {
          lastSavedBankRef.current = payload.customfield_10175;
        }
      })
      .catch((error) => {
        console.error("[JIRA] Eroare la salvarea bancii/IBAN:", {
          status: error.response?.status,
          message: error.message,
        });
      });
  };

  useEffect(() => {
    if (!issueId) return;

    const fieldsToUpdate = {};
    if (iban && iban !== lastSavedIbanRef.current) {
      fieldsToUpdate.customfield_10176 = iban;
    }
    if (bankName && bankName !== lastSavedBankRef.current) {
      fieldsToUpdate.customfield_10175 = bankName;
    }

    if (Object.keys(fieldsToUpdate).length === 0) return;

    setCustomFieldValues((prevValues) => ({
      ...prevValues,
      ...(fieldsToUpdate.customfield_10176
        ? { customfield_10176: fieldsToUpdate.customfield_10176 }
        : {}),
      ...(fieldsToUpdate.customfield_10175
        ? { customfield_10175: fieldsToUpdate.customfield_10175 }
        : {}),
    }));

    axios
      .put(
        `https://server-9p4hx.kinsta.app/api/tasks/jira-task/${issueId}`,
        fieldsToUpdate
      )
      .then(() => {
        if (fieldsToUpdate.customfield_10176) {
          lastSavedIbanRef.current = fieldsToUpdate.customfield_10176;
          console.log(
            "[OCR] IBAN salvat in JIRA:",
            fieldsToUpdate.customfield_10176,
            issueId
          );
        }
        if (fieldsToUpdate.customfield_10175) {
          lastSavedBankRef.current = fieldsToUpdate.customfield_10175;
          console.log(
            "[OCR] Banca salvata in JIRA:",
            fieldsToUpdate.customfield_10175,
            issueId
          );
        }
      })
      .catch((error) => {
        console.error("[OCR] Eroare la salvarea bancii/IBAN in JIRA:", error);
      });
  }, [iban, bankName, issueId]);

  const handleCreareActAditional = async () => {
    const validation = validateFields();
    setWarnings(validation.warnings);

    if (!validation.isValid) {
      return; // Nu trimite cererea dacă validarea eșuează
    }

    if (!vendorData) {
      alert("Datele vânzătorului nu sunt disponibile!");
      return;
    }

    if (!tipContract || tipContract === "Unknown") {
      await fetchTipContract();

      if (!tipContract || tipContract === "Unknown") {
        alert(
          "Tipul contractului nu a fost determinat corect. Verificați datele din task."
        );
        return;
      }
    }

    try {
      const addressCI =
        vendorData.addresses?.find((address) => address.categorie === "ci") ||
        {};
      const consolidatedAddress = `${addressCI.address_line1 || ""}, ${addressCI.city || ""}, ${addressCI.state || ""}, ${addressCI.country || ""}`;

      const requestData = {
        serieCI: vendorData.vendor?.serieCI || "N/A",
        nrCI: vendorData.vendor?.nrCI || "N/A",
        adresaLinia1: consolidatedAddress || "Adresă indisponibilă",
        email: vendorData.vendor?.email || "",
        telefon: vendorData.vendor?.phone || "",
        Tip_Contract: tipContract,
        nume: vendorData.vendor?.name || "",
        pretFinal: customFieldValues.customfield_10181 || "0",
        NrContract: customFieldValues.customfield_10066 || "N/A",
        dataIntrare: customFieldValues.customfield_10077 || "N/A",
      };

      const response = await axios.post(
        "https://server-9p4hx.kinsta.app/api/contracts/signnow/workflow-act-aditional-diminuare",
        requestData
      );

      if (response.data.success) {
        setAlertMessage(
          response.data.message ||
            "Actul adițional a fost creat și trimis cu succes!"
        );
        setAlertType("success"); // Tipul succes
        setShowAlert(true); // Afișează alerta
      } else {
        setAlertMessage(
          response.data.message ||
            "A apărut o eroare la crearea actului adițional."
        );
        setAlertType("error"); // Tipul eroare
        setShowAlert(true); // Afișează alerta
      }
    } catch (error) {
      setAlertMessage(
        error.response?.data?.message ||
          "A apărut o eroare la crearea actului adițional."
      );
      setAlertType("error"); // Tipul eroare
      setShowAlert(true); // Afișează alerta
    }
  };

  useEffect(() => {
    if (!email || email.trim() === "") {
      console.warn("Skipping API call due to empty email");
      return;
    }

    const fetchRequests = async () => {
      try {
        const response = await axios.get(
          `https://server-9p4hx.kinsta.app/api/tasks/jira-by-email?email=${email}`
        );
        console.log("Fetched requests:", response.data);
      } catch (error) {
        console.error("Error fetching requests:", error);
      }
    };

    fetchRequests();
  }, [email]);

  const fetchVendorData = async () => {
    if (!email) {
      console.warn("Email is undefined, skipping fetchVendorData");
      return;
    }

    try {
      const response = await axios.get(
        `https://server-9p4hx.kinsta.app/api/tasks/vendor/${email}`
      );
      setVendorData(response.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn("Vendor not found.");
        setVendorData(null); // Inițializează cu null sau date implicite
      } else {
        console.error("Error fetching vendor data:", {
          status: error.response?.status,
          message: error.message,
        });
      }
    }
  };

  useEffect(() => {
    const fetchCustomFieldOptions = async () => {
      const fieldId = "customfield_10183";
      try {
        const response = await axios.get(
          `https://server-9p4hx.kinsta.app/api/tasks/jira-custom-field-options/${fieldId}`
        );
        const options = response.data;
        console.log("Fetched custom field options:", options); // Verifică răspunsul complet
        setCustomFieldOptions((prev) => ({
          ...prev,
          [fieldId]: options,
        }));
      } catch (error) {
        console.error("Error fetching custom field options:", error);
      }
    };

    fetchCustomFieldOptions();
  }, []);

  const fetchTipContract = async () => {
    const fieldId = "customfield_10183";
    try {
      // Fetch task details
      const taskResponse = await axios.get(
        `https://server-9p4hx.kinsta.app/api/tasks/jira-task-qc/${issueId}/fields`
      );
      const taskData = taskResponse.data;

      console.log("JIRA task response:", taskData); // Loghează răspunsul complet pentru debugging

      // Verificăm dacă există deja câmpul `Contract` și îl folosim
      if (taskData.Contract) {
        setTipContract(taskData.Contract);
        console.log(
          "Tip Contract setat direct din Contract:",
          taskData.Contract
        );
        return;
      }

      // Continuăm logica normală dacă `Contract` nu este disponibil
      const jiraValue = taskData?.customfield_10183;
      if (!jiraValue) {
        console.warn(
          `JIRA field ${fieldId} is missing or undefined:`,
          taskData
        );
        setTipContract("Unknown");
        return;
      }

      console.log(`JIRA value for ${fieldId}:`, jiraValue);

      // Fetch custom field options
      const optionsResponse = await axios.get(
        `https://server-9p4hx.kinsta.app/api/tasks/jira-custom-field-options/${fieldId}`
      );
      const fieldOptions = optionsResponse.data;

      console.log(`Fetched options for ${fieldId}:`, fieldOptions);

      // Map the value to the corresponding label
      const matchedOption = fieldOptions.find((opt) => opt.value === jiraValue);

      if (!matchedOption) {
        console.warn(
          `No matching option found for ${jiraValue} in field ${fieldId}`
        );
        setTipContract("Unknown");
      } else {
        setTipContract(matchedOption.label);
        console.log("Mapped Tip_Contract:", matchedOption.label);
      }
    } catch (error) {
      console.error("Error fetching Tip_Contract:", error);
      setTipContract("Unknown");
    }
  };

  const validateFields = () => {
    const addressCI =
      vendorData?.addresses?.find((address) => address.categorie === "ci") ||
      {};
    const isAddressComplete =
      addressCI.address_line1 &&
      addressCI.city &&
      addressCI.state &&
      addressCI.postal_code &&
      addressCI.country;
    const isVendorDataComplete =
      vendorData?.vendor?.serieCI && vendorData?.vendor?.nrCI;
    const isJiraDataComplete =
      tipContract &&
      customFieldValues.customfield_10066 &&
      customFieldValues.customfield_10181;

    const warnings = {
      address: !isAddressComplete
        ? "Te rog completează corect adresa și datele din buletin pentru a crea actul adițional."
        : null,
      jiraData: !isJiraDataComplete
        ? "Te rog completează corect datele în JIRA în proiectul LEB."
        : null,
    };

    return {
      isValid: isAddressComplete && isVendorDataComplete && isJiraDataComplete,
      warnings,
    };
  };

  const validation = validateFields();
  const isButtonDisabled = !validation.isValid;

  const retryFetchTipContract = async (retries = 3) => {
    for (let i = 0; i < retries; i++) {
      await fetchTipContract();
      if (tipContract && tipContract !== "Unknown") {
        console.log("Tip Contract set successfully:", tipContract);
        break; // Exit the loop if tipContract is valid
      }
      console.warn(`Retrying fetchTipContract... Attempt ${i + 1}`);
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Wait 1 second before retrying
    }
  };

  const handleOnlineAction = async (action) => {
    try {
      const payload = {
        status: "44_PRELUNGIT", // Target status
        //customFields: {
        //    customfield_10085: action, // Example: 'Automat' or 'ACT'
        //},
      };

      console.log(
        "Request URL:",
        buildStatusApiUrl(`/api/tasks/set-status/${summary}`)
      );
      console.log("Request Payload:", payload);

      axios
        .post(
          buildStatusApiUrl(`/api/tasks/set-status/${summary}`),
          payload,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          console.log("Response:", response.data);
        })
        .catch((error) => {
          console.error(
            "Error:",
            error.response ? error.response.data : error.message
          );
        });

      console.log(`Sending payload:`, payload);

      const response = await axios.post(
        buildStatusApiUrl(`/api/tasks/set-status/${summary}`),
        payload
      );

      if (response.status === 200) {
        console.log(
          `Task updated successfully with status "44_PRELUNGIT" and customFields:`,
          payload.customFields
        );
        alert(`Task updated successfully with status "44_PRELUNGIT"`);
      } else {
        console.error(
          "An error occurred while updating the task:",
          response.data
        );
        alert("An error occurred while updating the task.");
      }
    } catch (error) {
      console.error(
        "Error updating task in CONT:",
        error.response?.data || error.message
      );
      alert("An error occurred while updating the task.");
    }
  };

  const handleRestituitAction = () => {
    const transition = transitions.find((t) => t.name === "RESTITUIT"); // Căutăm tranziția "RESTITUIT"
    if (!transition) {
      const message = 'No transition found for status "RESTITUIT"';
      setError(message);
      showStatusError('Nu există tranziția către "RESTITUIT".');
      return;
    }

    const transitionId = transition.id;

    axios
      .post(buildStatusApiUrl("/api/tasks/jira-transition"), {
        issueId,
        transitionId,
      })
      .then(() => {
        completeSuccessfulTransition("RESTITUIT"); // Setăm noul status la "RESTITUIT"
      })
      .catch((error) => {
        console.error(
          'There was an error performing the transition to "RESTITUIT"!',
          error
        );
        const message = getStatusErrorMessage(
          error,
          'There was an error performing the transition to "RESTITUIT"!'
        );
        setError(message);
        showStatusError(message);
      });
  };

  const extractNrJurnal = (description) => {
    const match = description.match(/Unique\s*I\s*D\s*[\t ]*([\d]+)/i);
    return match ? match[1] : null; // Returnăm valoarea dacă este găsită, altfel null
  };

  useEffect(() => {
    retryFetchTipContract();
  }, [issueId]);

  useEffect(() => {
    if (issueId) {
      fetchTipContract();
    }
  }, [issueId]);

  useEffect(() => {
    const validateTipContract = async () => {
      if (tipContract === "Unknown") {
        console.warn("TipContract este necunoscut. Încercăm să revalidăm...");
        await fetchTipContract();
      }
    };

    validateTipContract();
  }, [tipContract]);

  useEffect(() => {
    if (email) {
      console.log("Email updated, fetching vendor data...");
      fetchVendorData();
    } else {
      console.warn("Email is undefined, skipping fetchVendorData");
    }
  }, [email]);

  useEffect(() => {
    console.log("Warnings:", warnings);
  }, [warnings]);

  console.log("→ customFieldValues:", {
    pretCuvenit: customFieldValues.customfield_10181,
    categoria: customFieldValues.customfield_10173,
    brand: customFieldValues.customfield_10070,
    model: customFieldValues.customfield_10107,
  });

  const wooPostId = getWooPostIdFromSku(customFieldValues.customfield_10083);

  return (
    <>
      {showAnalysis ? (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "#fff",
            zIndex: 1300,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto", // Permite scroll-ul pe axa verticală
          }}
        >
          <Button
            variant="contained"
            onClick={handleBackFromAnalysis}
            sx={{ margin: "20px", width: "100px" }}
          >
            Back
          </Button>
          <Page18 manualAvgPrice={manualAvgPrice} />{" "}
          {/* Transmiterea prețului către Page18 */}
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            width: "100%",
            maxWidth: "1000px",
            minWidth: 0,
            boxSizing: "border-box",
            overflowX: "clip",
            marginRight: "auto",
            marginLeft: "auto",
            ...style,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              mb: 2,
            }}
          >
            <IconButton
              onClick={handleOpenJira}
              disabled={!issueId}
              title="Deschide task in Jira"
              sx={{
                backgroundColor: "rgba(0,0,0,0.05)",
                "&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
              }}
            >
              <OpenInNewIcon />
            </IconButton>
            <IconButton
              onClick={handleOpenWooAdmin}
              disabled={!wooPostId}
              title="Deschide produs in Woo"
              sx={{
                backgroundColor: "rgba(0,0,0,0.05)",
                "&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
              }}
            >
              <StorefrontIcon />
            </IconButton>
            <IconButton
              onClick={handlePanelClose}
              sx={{
                backgroundColor: "rgba(0,0,0,0.05)",
                "&:hover": { backgroundColor: "rgba(0,0,0,0.1)" },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Snackbar
            open={statusFeedback.open}
            autoHideDuration={statusFeedback.severity === "success" ? 3000 : 5000}
            onClose={handleStatusFeedbackClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            sx={{
              zIndex: (theme) => theme.zIndex.modal + 2,
              bottom: { xs: 24, sm: 32 },
            }}
          >
            <Alert
              severity={statusFeedback.severity}
              variant="filled"
              onClose={handleStatusFeedbackClose}
              icon={
                statusFeedback.severity === "success" ? (
                  <CheckCircleOutlineIcon fontSize="inherit" />
                ) : (
                  <ErrorOutlineIcon fontSize="inherit" />
                )
              }
              sx={{
                minWidth: { xs: "calc(100vw - 32px)", sm: 360 },
                maxWidth: { xs: "calc(100vw - 32px)", sm: 520 },
                borderRadius: "10px",
                boxShadow: "0 14px 36px rgba(0, 0, 0, 0.22)",
                fontWeight: 700,
                alignItems: "center",
                backgroundColor:
                  statusFeedback.severity === "success" ? "#2e7d32" : "#d32f2f",
                color: "#fff",
                "& .MuiAlert-message": {
                  width: "100%",
                  textAlign: "center",
                },
              }}
            >
              {statusFeedback.message}
            </Alert>
          </Snackbar>

          {firstImageAttachment && (
            <Box
              ref={mainImageDropRef}
              onDrop={handleDrop}
              onDragEnter={(e) => {
                e.preventDefault();
                e.dataTransfer.dropEffect = "move";
                setIsMainImageDragOver(true);
              }}
              onDragOver={(e) => {
                e.preventDefault();
                e.dataTransfer.dropEffect = "move";
                setIsMainImageDragOver(true);
              }}
              onDragLeave={(e) => {
                if (!e.currentTarget.contains(e.relatedTarget)) {
                  setIsMainImageDragOver(false);
                }
              }}
              sx={{
                position: "relative",
                width: "95%",
                border: isMainImageDragOver
                  ? "3px solid #1E90FF"
                  : "3px solid transparent",
                borderRadius: "10px",
                transition: "border-color 160ms ease, box-shadow 160ms ease",
                boxShadow: isMainImageDragOver
                  ? "0 0 0 4px rgba(30, 144, 255, 0.18)"
                  : "none",
              }}
            >
              <img
                src={getAttachmentImageUrl(firstImageAttachment.id)}
                alt={firstImageAttachment.filename}
                draggable={false}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.dataTransfer.dropEffect = "move";
                }}
                onDrop={handleDrop}
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  marginBottom: "20px",
                }}
              />
              <IconButton
                onClick={handleMainImageIconClick}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  backgroundColor: "#fff",
                  boxShadow: 1,
                }}
              >
                <EditIcon />
              </IconButton>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleMainImageUpload}
              />
            </Box>
          )}
          {pointerDragPreview?.attachment && (
            <Box
              sx={{
                position: "fixed",
                left: pointerDragPreview.x + 14,
                top: pointerDragPreview.y + 14,
                width: 88,
                height: 88,
                p: 0.5,
                zIndex: 9999,
                pointerEvents: "none",
                borderRadius: 1.5,
                border: "2px solid #1E90FF",
                bgcolor: "#fff",
                boxShadow: "0 16px 34px rgba(15, 23, 42, 0.24)",
              }}
            >
              <img
                src={getAttachmentImageUrl(pointerDragPreview.attachment.id)}
                alt={pointerDragPreview.attachment.filename}
                draggable={false}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "8px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexWrap: "wrap",
              gap: 1,
              marginBottom: "20px",
            }}
          >
            {attachments
              .filter(
                (att) =>
                  String(att?.id || "") !==
                  String(firstImageAttachment?.id || "")
              )
              .map((att) => (
                <Box key={att.id}>{renderAttachmentPreview(att)}</Box>
              ))}
          </Box>
          {isEditingSummary ? (
            <input
              type="text"
              value={newSummary}
              onChange={handleSummaryChange}
              onBlur={handleSummaryBlur}
              autoFocus
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                width: "100%",
                border: "none",
                outline: "none",
                marginBottom: "20px",
              }}
            />
          ) : (
            <Typography
              variant="h5"
              component="h2"
              onClick={handleSummaryClick}
              sx={{
                cursor: "pointer",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {summary}
            </Typography>
          )}
          {error && <p style={{ color: "red" }}>{error}</p>}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
              gap: "16px", // Spațiu fix între butoane
            }}
          >
            {(tab === "created" || tab === "prospect") && (
              <Button
                variant="contained"
                onClick={handleAccept}
                sx={{
                  flex: 1, // Fiecare buton ocupă spațiu egal
                  backgroundColor: tab === "created" ? "#1E90FF" : "#32CD32",
                  "&:hover": {
                    backgroundColor: tab === "created" ? "#1C86EE" : "#228B22",
                  },
                  color: "#FFFFFF",
                  fontSize: "14px",
                  fontWeight: "bold",
                  textTransform: "none",
                  height: "40px",
                  borderRadius: "8px",
                }}
              >
                {tab === "created" ? "Prospect" : "Acceptat"}
              </Button>
            )}

            {tab === "acceptat" && (
              <Button
                variant="contained"
                onClick={handleTransit}
                sx={{
                  flex: 1, // Fiecare buton ocupă spațiu egal
                  backgroundColor: "#1E90FF",
                  "&:hover": {
                    backgroundColor: "#1C86EE",
                  },
                  color: "#FFFFFF",
                  fontSize: "14px",
                  fontWeight: "bold",
                  textTransform: "none",
                  height: "40px",
                  borderRadius: "8px",
                }}
              >
                Tranzit
              </Button>
            )}

            {tab === "tranzit" && (
              <Button
                variant="contained"
                onClick={handleAutentificare}
                sx={{
                  flex: 1,
                  backgroundColor: "#FF4500",
                  "&:hover": {
                    backgroundColor: "#FF6347",
                  },
                  color: "#FFFFFF",
                  fontSize: "14px",
                  fontWeight: "bold",
                  textTransform: "none",
                  height: "40px",
                  borderRadius: "8px",
                }}
              >
                AUTENTIFICARE
              </Button>
            )}

            {tab === "autentificare" && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "16px",
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  onClick={handleOnline}
                  sx={{
                    flex: 1,
                    backgroundColor: "#1E90FF",
                    "&:hover": {
                      backgroundColor: "#1C86EE",
                    },
                    color: "#FFFFFF",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textTransform: "none",
                    height: "40px",
                    borderRadius: "8px",
                  }}
                >
                  ONLINE
                </Button>
                <Button
                  variant="contained"
                  onClick={
                    stocExternLabel === "da" ? handleVandut : handleRespins
                  }
                  sx={{
                    flex: 1,
                    backgroundColor: "#FF4500",
                    "&:hover": {
                      backgroundColor: "#FF6347",
                    },
                    color: "#FFFFFF",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textTransform: "none",
                    height: "40px",
                    borderRadius: "8px",
                  }}
                >
                  {stocExternLabel === "da" ? "VANDUT" : "RESPINS"}
                </Button>
              </Box>
            )}

            {tab !== "restituiri" &&
              tab !== "autentificare" &&
              tab !== "online" &&
              tab !== "prospect" &&
              tab !== "tranzit" &&
              tab !== "created" &&
              tab !== "acceptat" && (
                <Button
                  variant="contained"
                  onClick={handleRefuse}
                  sx={{
                    flex: 1,
                    backgroundColor: "#FFD700",
                    "&:hover": {
                      backgroundColor: "#FFC700",
                    },
                    color: "#FF8C00",
                    fontSize: "14px",
                    fontWeight: "bold",
                    textTransform: "none",
                    height: "40px",
                    borderRadius: "8px",
                  }}
                >
                  Refuzat
                </Button>
              )}

            {tab !== "restituiri" &&
              tab !== "autentificare" &&
              tab !== "online" &&
              ((tab === "acceptat" && stocExternLabel === "da") ||
              (tab === "created" && stocExternLabel === "da") ? (
                <Button
                  variant="contained"
                  onClick={handleAutentificare}
                  sx={{
                    flex: 1,
                    backgroundColor: "#FF4500",
                    "&:hover": { backgroundColor: "#FF6347" },
                    color: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: "bold",
                    textTransform: "none",
                    height: "40px",
                    borderRadius: "8px",
                  }}
                >
                  AUTENTIFICARE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleOpenPopup}
                  sx={{
                    flex: 1,
                    backgroundColor: "#FF4500",
                    "&:hover": { backgroundColor: "#FF6347" },
                    color: "#FFFFFF",
                    fontSize: "14px",
                    fontWeight: "bold",
                    textTransform: "none",
                    height: "40px",
                    borderRadius: "8px",
                  }}
                >
                  Refuz Total
                </Button>
              ))}

            {tab === "online" && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "16px",
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => handleOnlineAction("Automat")}
                  sx={{
                    flex: 1,
                    backgroundColor: "#4CAF50",
                    "&:hover": { backgroundColor: "#45A049" },
                    color: "#fff",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                >
                  Automat
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleOnlineAction("Act")}
                  sx={{
                    flex: 1,
                    backgroundColor: "#2196F3",
                    "&:hover": { backgroundColor: "#1976D2" },
                    color: "#fff",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                >
                  Prelungit Act
                </Button>
                <Button
                  variant="contained"
                  onClick={handleRestituitAction}
                  sx={{
                    flex: 1,
                    backgroundColor: "#FF5722",
                    "&:hover": { backgroundColor: "#E64A19" },
                    color: "#fff",
                    fontWeight: "bold",
                    textTransform: "none",
                  }}
                >
                  Restituit
                </Button>
              </Box>
            )}

            <Modal open={showPopup} onClose={handleClosePopup}>
              <Card
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "400px",
                  padding: "20px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                }}
              >
                <CardContent>
                  <Typography variant="h6" sx={{ marginBottom: "20px" }}>
                    {pendingRefuseAction === "totalRefuse"
                      ? "Selectați motivul refuzului total"
                      : "Selectați motivul refuzului"}
                  </Typography>
                  <Select
                    value={selectedReason}
                    onChange={(e) => handleReasonChange(e.target.value)}
                    fullWidth
                    displayEmpty
                    sx={{ marginBottom: "20px" }}
                  >
                    <MenuItem value="" disabled>
                      Selectați un motiv
                    </MenuItem>
                    {salReasons.map((reason, index) => (
                      <MenuItem key={index} value={reason}>
                        {reason}
                      </MenuItem>
                    ))}
                  </Select>
                  <Typography variant="body1" sx={{ marginBottom: "10px" }}>
                    Detalii suplimentare:
                  </Typography>
                  <TextField
                    value={details}
                    onChange={(e) => setDetails(e.target.value)}
                    multiline
                    rows={4}
                    fullWidth
                    placeholder="Introduceți detalii suplimentare..."
                    variant="outlined"
                    sx={{ marginBottom: "20px" }}
                  />
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleSaveRefuse}
                      sx={{
                        backgroundColor: "#FF4500",
                        "&:hover": { backgroundColor: "#FF6347" },
                        color: "#FFFFFF",
                      }}
                    >
                      {pendingRefuseAction === "totalRefuse"
                        ? "Refuz Total"
                        : "Refuză"}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleClosePopup}
                      sx={{
                        borderColor: "#CCCCCC",
                        color: "#000",
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Modal>
          </Box>

          {tab !== "restituiri" && (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "20px",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="subtitle1"
                    component="h3"
                    sx={{ marginLeft: "40px" }}
                  >
                    Dețin:
                  </Typography>
                  <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                    {tags.map((tag, index) => (
                      <Chip
                        key={index}
                        label={tag}
                        onDelete={handleDeleteTag(tag)}
                        sx={{ margin: "5px" }}
                      />
                    ))}
                  </Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="subtitle1"
                    component="h3"
                    sx={{ marginLeft: "95px" }}
                  >
                    Condiție:
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    sx={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginLeft: "90px",
                    }}
                  >
                    {customFieldValues.condition || "N/A"}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="subtitle1"
                    component="h3"
                    sx={{ marginLeft: "95px" }}
                  >
                    Preț:
                  </Typography>
                  <Typography
                    variant="body1"
                    component="p"
                    sx={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginLeft: "90px",
                    }}
                  >
                    {price} €
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: "1",
                  }}
                >
                  <PersonIcon sx={{ color: "#6a0dad" }} />
                  <TextField
                    value={name}
                    onChange={(e) =>
                      setName(e.target.value.replace(/\s+/g, " "))
                    }
                    onBlur={handleSaveName}
                    placeholder="Nume"
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                      sx: { fontSize: "16px", textAlign: "center" },
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: "1",
                    marginLeft: "20px",
                  }}
                >
                  <PhoneIcon sx={{ color: "#6a0dad" }} />
                  <TextField
                    value={phone}
                    onChange={(e) =>
                      setPhone(e.target.value.replace(/\s+/g, " "))
                    }
                    onBlur={handleSavePhone}
                    placeholder="Telefon"
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                      sx: { fontSize: "16px", textAlign: "center" },
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: "1",
                  }}
                >
                  <EmailIcon sx={{ color: "#6a0dad" }} />
                  <TextField
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onBlur={handleSaveEmail}
                    placeholder="Email"
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                      sx: { fontSize: "16px", textAlign: "center" },
                    }}
                  />
                </Box>
              </Box>
            </>
          )}
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {/* MDetalii vanzator */}
            <VendorInfo
              email={email || emailFromRestituit}
              initialName={name || returNume}
              initialPhone={phone || returTelefon}
              initialBankName={customFieldValues.customfield_10175}
              initialIban={customFieldValues.customfield_10176}
              onAddressSelect={handleAddressSelect}
              onVendorDataChange={setVendorData}
            />
            {/* ActiveRequests este ascuns pentru taburile autentificare, online și restituiri */}
            {tab !== "restituiri" && (
              <Box>
                <ActiveRequests email={email} />
              </Box>
            )}
          </Box>

          {/* Afișăm accordeonul "Istoric" și "Cautare produs AI" doar pentru taburile "created" și "prospect" */}
          {tab === "created" || tab === "prospect" ? (
            <>
              {renderHistory()}
              <Accordion
                sx={{ boxShadow: "none", border: "none" }}
                expanded={expandedSearch}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  onClick={() => setExpandedSearch(!expandedSearch)}
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    padding: "0 16px",
                  }}
                >
                  <ImgIcon
                    style={{
                      marginRight: "16px",
                      width: "48px",
                      height: "48px",
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Typography
                      variant="h6"
                      component="h3"
                      sx={{
                        fontSize: "18px",
                        marginRight: "8px",
                        marginTop: "8px",
                        lineHeight: "1",
                        textAlign: "left",
                      }}
                    >
                      Cautare produs AI
                    </Typography>
                    {imageSearchResults.length > 0 && (
                      <Typography
                        variant="body2"
                        component="p"
                        sx={{ color: "grey", textAlign: "left" }}
                      >
                        {imageSearchResults.length} results
                      </Typography>
                    )}
                  </Box>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    backgroundColor: "#fff",
                    border: "1px solid #fff",
                    borderRadius: "8px",
                    padding: "16px",
                  }}
                >
                  {isSearching ? (
                    <LoadingAnimation />
                  ) : (
                    <List>
                      {imageSearchResults.map((result, index) => (
                        <ListItem
                          key={index}
                          sx={{
                            backgroundColor: "#fff",
                            border: "1px solid #fff",
                            borderRadius: "8px",
                            marginBottom: "10px",
                          }}
                        >
                          <ListItemText
                            primary={
                              <Link href={result.link} target="_blank">
                                {result.title}
                              </Link>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  )}
                </AccordionDetails>
              </Accordion>
            </>
          ) : tab === "acceptat" ? (
            <>
              {/* Acte Confidentiale Accordion */}
              <ActeConfidentiale
                email={email}
                setIban={setIban}
                setBankName={setBankName}
                onIdCardParsed={handleIdCardParsed}
              />
              {showOcrSaveAlert && (
                <Box sx={{ marginTop: 2 }}>
                  <Alert
                    severity={ocrSaveType || "success"}
                    onClose={() => setShowOcrSaveAlert(false)}
                    sx={{ borderRadius: "8px" }}
                  >
                    {ocrSaveMessage}
                  </Alert>
                </Box>
              )}

              {/* Creare Contract Accordion */}
              <Accordion sx={{ boxShadow: "none", border: "none" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ backgroundColor: "#fff", padding: "0 16px" }}
                >
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: "bold", color: "#6a0dad" }}
                  >
                    Creare Contract
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{ backgroundColor: "#fff", padding: "16px" }}
                >
                  <CreareContractForm
                    id={cerereId}
                    issueId={issueId}
                    contractData={{
                      ...contractData,
                      contCurent: iban || customFieldValues.customfield_10176 || "",
                      banca: bankName || customFieldValues.customfield_10175 || "",
                      pretFinalVanzare:
                        customFieldValues.customfield_10195 || "",
                      dataPlataFinalVanzare:
                        customFieldValues.customfield_10194 || "",
                      pretCuvenit: customFieldValues.customfield_10072 || "",
                      brand: customFieldValues.customfield_10070 || "",
                      model: customFieldValues.customfield_10107 || "",
                      categoria:
                        customFieldOptions.customfield_10173?.find(
                          (option) =>
                            option.value === customFieldValues.customfield_10173
                        )?.label || "",
                      nrContract: customFieldValues.customfield_10066 || "",
                    }}
                    handleInputChange={handleContractInputChange}
                  />
                </AccordionDetails>
              </Accordion>

              {/* Creare AWB Accordion */}
              <AwbAccordion
                issueId={issueId}
                contactName={name || contractData.nume}
                contactPhone={phone || contractData.telefon}
                contactEmail={email || contractData.email}
                selectedAddress={selectedAddress}
              />
            </>
          ) : null}

          {tab === "restituiri" && (
            <>
              {/* Creare AWB Accordion */}
              <AwbAccordion
                issueId={issueId}
                contactName={name || contractData.nume || returNume}
                contactPhone={phone || contractData.telefon || returTelefon}
                contactEmail={email || contractData.email || returEmail}
                selectedAddress={selectedAddress}
                tab={tab}
                returId={cerereId}
              />
              {/* Creare Contract Accordion */}

              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#6a0dad" }}
              >
                Creare Nota Retur
              </Typography>

              <CreareaCerereRetur id={cerereId} />
            </>
          )}

          {tab === "online" &&
            (vendorData ? (
              <Box sx={{ marginTop: 3 }}>
                {/* Preț Act și Expiră pe același rând */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    marginBottom: "20px",
                  }}
                >
                  {/* Input-box pentru Preț Act */}
                  <Box sx={{ flex: 1 }}>
                    <Typography>
                      <strong>Preț Act:</strong>
                    </Typography>
                    <TextField
                      value={customFieldValues.customfield_10181}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10181",
                          e.target.value
                        )
                      }
                      placeholder="Introduceți prețul actului"
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <Typography
                            sx={{ marginLeft: "8px", fontWeight: "bold" }}
                          >
                            RON
                          </Typography>
                        ),
                      }}
                      fullWidth
                    />
                  </Box>

                  {/* Input-box pentru Expiră */}
                  <Box sx={{ flex: 1 }}>
                    <Typography>
                      <strong>Expiră:</strong>
                    </Typography>
                    <TextField
                      type="date"
                      value={customFieldValues.customfield_10078}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10078",
                          e.target.value
                        )
                      }
                      placeholder="Introduceți data expirării"
                      variant="outlined"
                      fullWidth
                    />
                  </Box>
                </Box>
                <Box sx={{ flex: 1, marginBottom: "20px" }}>
                  <Typography>
                    <strong>Tip Contract:</strong>
                  </Typography>
                  <Select
                    value={customFieldValues.customfield_10183}
                    onChange={(e) =>
                      handleCustomFieldChange(
                        "customfield_10183",
                        e.target.value
                      )
                    }
                    variant="outlined"
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    sx={{ marginLeft: "40px", fontSize: "16px", width: "80%" }}
                  >
                    <MenuItem value="" disabled>
                      Select Luxura Policy
                    </MenuItem>
                    {customFieldOptions.customfield_10183 &&
                      customFieldOptions.customfield_10183.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                  </Select>
                </Box>
                {/* Serie și Nr CI */}
                <Typography>
                  <strong>Serie CI:</strong>{" "}
                  {vendorData.vendor.serieCI || "N/A"}
                </Typography>
                <Typography>
                  <strong>Nr CI:</strong> {vendorData.vendor.nrCI || "N/A"}
                </Typography>

                {/* Adresă cu categoria 'ci' */}
                {vendorData.addresses &&
                vendorData.addresses.some((addr) => addr.categorie === "ci") ? (
                  vendorData.addresses
                    .filter((address) => address.categorie === "ci")
                    .map((address, index) => (
                      <Box key={index} sx={{ marginBottom: 1 }}>
                        <Typography>
                          <strong>Linia 1:</strong>{" "}
                          {address.address_line1 || "N/A"}
                        </Typography>
                        <Typography>
                          <strong>Linia 2:</strong>{" "}
                          {address.address_line2 || "N/A"}
                        </Typography>
                        <Typography>
                          <strong>Oraș:</strong> {address.city || "N/A"}
                        </Typography>
                        <Typography>
                          <strong>Județ:</strong> {address.state || "N/A"}
                        </Typography>
                        <Typography>
                          <strong>Cod Poștal:</strong>{" "}
                          {address.postal_code || "N/A"}
                        </Typography>
                        <Typography>
                          <strong>Țară:</strong> {address.country || "N/A"}
                        </Typography>
                      </Box>
                    ))
                ) : (
                  <Typography variant="body1">Nu există adresă CI.</Typography>
                )}

                {/* Tip Contract și Nr Contract */}
                <Typography sx={{ marginTop: 2 }}>
                  <strong>Tip Contract:</strong> {tipContract || "N/A"}
                </Typography>
                <Typography>
                  <strong>Nr Contract:</strong>{" "}
                  {customFieldValues.customfield_10066 || "N/A"}
                </Typography>
                <Typography>
                  <strong>Preț Final:</strong>{" "}
                  {customFieldValues.customfield_10181 || "N/A"}
                </Typography>

                {/* Buton pentru Creare Act Adițional */}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 2,
                  }}
                >
                  <Box>
                    {(warnings.address || warnings.jiraData) && (
                      <Box
                        sx={{ border: "1px solid blue", marginBottom: "20px" }}
                      >
                        {warnings.address && (
                          <Alert
                            severity="error"
                            sx={{ marginBottom: "10px", borderRadius: "8px" }}
                          >
                            {warnings.address}
                          </Alert>
                        )}
                        {warnings.jiraData && (
                          <Alert
                            severity="error"
                            sx={{ marginBottom: "10px", borderRadius: "8px" }}
                          >
                            {warnings.jiraData}
                          </Alert>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box sx={{ marginTop: 3 }}>
                <Typography
                  variant="subtitle1"
                  component="h3"
                  sx={{ marginLeft: "40px" }}
                >
                  Luxura Policy:
                </Typography>
                <Select
                  value={customFieldValues.customfield_10183}
                  onChange={(e) =>
                    handleCustomFieldChange("customfield_10183", e.target.value)
                  }
                  variant="outlined"
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{ marginLeft: "40px", fontSize: "16px", width: "80%" }}
                >
                  <MenuItem value="" disabled>
                    Select Luxura Policy
                  </MenuItem>
                  {customFieldOptions.customfield_10183 &&
                    customFieldOptions.customfield_10183.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                </Select>
              </Box>
            ))}

          {showAlert && (
            <Box sx={{ marginBottom: 2 }}>
              <Alert
                severity={alertType} // 'success' sau 'error'
                onClose={() => setShowAlert(false)} // Închide alerta
                sx={{
                  borderRadius: "8px",
                  backgroundColor:
                    alertType === "success" ? "#E8F5E9" : "#FFEBEE",
                  color: alertType === "success" ? "#388E3C" : "#D32F2F",
                  fontWeight: "bold",
                }}
                icon={
                  alertType === "success" ? (
                    <CheckCircleOutlineIcon fontSize="inherit" />
                  ) : (
                    <ErrorOutlineIcon fontSize="inherit" />
                  )
                }
              >
                {alertMessage}
              </Alert>
            </Box>
          )}

          {tab !== "autentificare" &&
            tab !== "online" &&
            tab !== "restituiri" && (
              <>
                <Box sx={{ ...sectionRowSx, marginTop: "20px" }}>
                  <Box sx={{ ...fieldCardSx, background: stocExternBg }}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Stoc Extern:
                    </Typography>
                    <Select
                      value={customFieldValues.customfield_10337 || ""}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10337",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{ ...controlSx, width: "100%" }}
                    >
                      <MenuItem value="" disabled>
                        Select Stoc Extern
                      </MenuItem>
                      {customFieldOptions.customfield_10337 &&
                        customFieldOptions.customfield_10337.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                </Box>
                <Box sx={{ ...sectionRowSx, marginTop: "20px" }}>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Tip Achizitie:
                    </Typography>
                    <Select
                      value={customFieldValues.customfield_10080 || ""}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10080",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={controlSx}
                    >
                      <MenuItem value="" disabled>
                        Select Tip Achizitie
                      </MenuItem>
                      {customFieldOptions.customfield_10080 &&
                        customFieldOptions.customfield_10080.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Luxura Policy:
                    </Typography>
                    <Select
                      value={customFieldValues.customfield_10183}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10183",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={controlSx}
                    >
                      <MenuItem value="" disabled>
                        Select Luxura Policy
                      </MenuItem>
                      {customFieldOptions.customfield_10183 &&
                        customFieldOptions.customfield_10183.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                </Box>
                <Box sx={sectionRowSx}>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Data de Intrare:
                    </Typography>
                    <TextField
                      type="date"
                      value={customFieldValues.customfield_10077}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10077",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={controlSx}
                    />
                  </Box>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Expira Contract:
                    </Typography>
                    <TextField
                      type="date"
                      value={customFieldValues.customfield_10078}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10078",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      sx={controlSx}
                    />
                  </Box>
                </Box>
                <Box sx={sectionRowSx}>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Nr Jurnal:
                    </Typography>
                    <TextField
                      value={customFieldValues.customfield_10066}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10066",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      fullWidth
                      sx={controlSx}
                    />
                  </Box>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Categorie:
                    </Typography>
                    <Select
                      value={customFieldValues.customfield_10173}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10173",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={controlSx}
                    >
                      <MenuItem value="" disabled>
                        Select Categorie
                      </MenuItem>
                      {customFieldOptions.customfield_10173 &&
                        customFieldOptions.customfield_10173.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                </Box>
                <Box sx={sectionRowSx}>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Preț de Intrare (RON):
                    </Typography>
                    <TextField
                      type="number"
                      value={customFieldValues.customfield_10072}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10072",
                          parseFloat(e.target.value)
                        )
                      }
                      variant="outlined"
                      fullWidth
                      sx={controlSx}
                    />
                  </Box>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Preț de Vânzare (RON):
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <TextField
                        type="number"
                        value={customFieldValues.customfield_10073}
                        onChange={(e) =>
                          handleCustomFieldChange(
                            "customfield_10073",
                            parseFloat(e.target.value)
                          )
                        }
                        variant="outlined"
                        fullWidth
                        sx={controlSx}
                      />
                      <Button
                        variant="contained"
                        onClick={handleAnalysisClick} // Acționează la clic pe Analiza
                        sx={{
                          minWidth: "40px",
                          minHeight: "40px",
                          padding: "8px",
                          backgroundColor: customFieldValues.customfield_10073
                            ? "#1E90FF"
                            : "#cccccc",
                          "&:hover": {
                            backgroundColor: customFieldValues.customfield_10073
                              ? "#1C86EE"
                              : "#cccccc",
                          },
                          color: "#FFFFFF",
                          borderRadius: "50%", // Face butonul rotund
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        disabled={!customFieldValues.customfield_10073}
                      >
                        <AnalysisIcon />
                      </Button>
                    </Box>
                  </Box>
                </Box>
                <Box sx={sectionRowSx}>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Achizitor:
                    </Typography>
                    <Select
                      value={customFieldValues.customfield_10165}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10165",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={controlSx}
                    >
                      <MenuItem value="" disabled>
                        Select Achizitor
                      </MenuItem>
                      {customFieldOptions.customfield_10165 &&
                        customFieldOptions.customfield_10165.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Contactat:
                    </Typography>
                    <Select
                      value={customFieldValues.customfield_10185}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10185",
                          e.target.value
                        )
                      }
                      variant="outlined"
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={controlSx}
                    >
                      <MenuItem value="" disabled>
                        Select Contactat
                      </MenuItem>
                      {customFieldOptions.customfield_10185 &&
                        customFieldOptions.customfield_10185.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                </Box>
                <Box sx={sectionRowSx}>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Brand:
                    </Typography>
                    <TextField
                      value={customFieldValues.customfield_10070}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10070",
                          e.target.value
                        )
                      }
                      placeholder="Introduce Brand"
                      variant="outlined"
                      fullWidth
                      sx={controlSx}
                    />
                  </Box>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Model:
                    </Typography>
                    <TextField
                      value={customFieldValues.customfield_10107}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10107",
                          e.target.value
                        )
                      }
                      placeholder="Introduce Model"
                      variant="outlined"
                      fullWidth
                      sx={controlSx}
                    />
                  </Box>
                </Box>
                <Box sx={sectionRowSx}>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      Banca:
                    </Typography>
                    <TextField
                      value={customFieldValues.customfield_10175}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10175",
                          e.target.value
                        )
                      }
                      placeholder="Introduce Banca"
                      variant="outlined"
                      fullWidth
                      sx={controlSx}
                    />
                  </Box>
                  <Box sx={fieldCardSx}>
                    <Typography
                      variant="subtitle1"
                      component="h3"
                      sx={fieldLabelSx}
                    >
                      IBAN:
                    </Typography>
                    <TextField
                      value={customFieldValues.customfield_10176}
                      onChange={(e) =>
                        handleCustomFieldChange(
                          "customfield_10176",
                          e.target.value
                        )
                      }
                      placeholder="Introduce IBAN"
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        sx: { textTransform: "uppercase" },
                      }}
                      sx={controlSx}
                    />
                    <Box sx={{ marginTop: "8px" }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleSaveBankIban}
                      >
                        Salvează banca și IBAN
                      </Button>
                    </Box>
                  </Box>
                </Box>
                <Box sx={{ ...sectionRowSx, flexDirection: "column" }}>
                  <Typography
                    variant="subtitle1"
                    component="h3"
                    sx={{ ...fieldLabelSx, marginLeft: "10px" }}
                  >
                    Adresa CI:
                  </Typography>
                  <TextField
                    value={customFieldValues.customfield_10166}
                    onChange={(e) =>
                      handleCustomFieldChange(
                        "customfield_10166",
                        e.target.value
                      )
                    }
                    placeholder="Introduce adresa completă"
                    multiline
                    rows={2}
                    variant="outlined"
                    fullWidth
                    sx={{ ...controlSx, marginLeft: "10px" }}
                  />
                </Box>
                <Box sx={{ ...sectionRowSx, flexDirection: "column" }}>
                  <Typography
                    variant="subtitle1"
                    component="h3"
                    sx={{ ...fieldLabelSx, marginLeft: "10px" }}
                  >
                    Nota interna:
                  </Typography>
                  <TextField
                    value={customFieldValues.customfield_10186}
                    onChange={(e) =>
                      handleCustomFieldChange(
                        "customfield_10186",
                        e.target.value
                      )
                    }
                    placeholder="Scrie aici nota interna"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    sx={{ ...controlSx, marginLeft: "10px" }}
                  />
                </Box>
              </>
            )}

          {tab === "autentificare" && (
            <AutentificareStep
              key={issueId} // adaugă acest key pentru a forța re-render
              issueId={issueId}
              customFieldValue={customFieldValues.customfield_10188}
              onUpdateCustomField={(newValue) =>
                handleCustomFieldChange("customfield_10188", newValue)
              }
              contactName={name} // Transmitem numele
              contactPhone={phone} // Transmitem telefonul
              contactEmail={email} // Transmitem emailul
              category={customFieldValues.customfield_10173} // Adăugăm categoria
              categoryLabel={
                customFieldOptions.customfield_10173?.find(
                  (option) =>
                    String(option.value) ===
                    String(customFieldValues.customfield_10173)
                )?.label || ""
              }
              summary={summary}
              nrContract={customFieldValues.customfield_10066}
              skuJira={customFieldValues.customfield_10083}
              selectedAddress={selectedAddress}
              mainImageAttachmentId={firstImageAttachment?.id || ""}
              vendorDataOverride={vendorData}
            />
          )}
          {tab !== "restituiri" && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                onClick={handleSave}
                sx={{
                  width: tab === "online" ? "48%" : "100%",
                  backgroundColor: "#87CEEB",
                  "&:hover": {
                    backgroundColor: "#00BFFF",
                  },
                  color: "#1E90FF",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  height: "48px",
                  borderRadius: "8px",
                }}
              >
                SAVE
              </Button>

              {(tab === "created" || tab === "prospect") && (
                <Button
                  variant="contained"
                  startIcon={<SearchIcon />}
                  onClick={handleImageSearch}
                  sx={{
                    width: "48%",
                    backgroundColor: "#FFD700",
                    "&:hover": {
                      backgroundColor: "#FFC700",
                    },
                    color: "#FF8C00",
                    justifyContent: "center",
                    fontSize: "16px",
                    fontWeight: "bold",
                    textTransform: "none",
                    height: "48px",
                    padding: "8px 16px",
                    borderRadius: "8px",
                    marginLeft: "10px",
                  }}
                >
                  SEARCH IMAGE
                </Button>
              )}

              {tab === "online" && (
                <Button
                  variant="contained"
                  startIcon={<CheckCircleIcon />}
                  onClick={handleCreareActAditional}
                  disabled={isButtonDisabled}
                  sx={{
                    width: "48%",
                    backgroundColor: isButtonDisabled ? "#ccc" : "#007BFF",
                    color: isButtonDisabled ? "#888" : "white",
                    fontWeight: "bold",
                    padding: "8px 16px",
                    fontSize: "16px",
                    borderRadius: "8px",
                    boxShadow: isButtonDisabled
                      ? "none"
                      : "0 4px 12px rgba(0, 123, 255, 0.3)",
                    "&:hover": {
                      backgroundColor: isButtonDisabled ? "#ccc" : "#0056b3",
                    },
                  }}
                >
                  Act Adițional
                </Button>
              )}
            </Box>
          )}
        </Box>
      )}
    </>
  );
};
export default TaskEdit;
